module.exports = function (r) {
  function t(o) {
    if (e[o]) return e[o].exports;
    var n = e[o] = {
      i: o,
      l: !1,
      exports: {}
    };
    return r[o].call(n.exports, n, n.exports, t), n.l = !0, n.exports;
  }

  var e = {};
  return t.m = r, t.c = e, t.d = function (r, e, o) {
    t.o(r, e) || Object.defineProperty(r, e, {
      configurable: !1,
      enumerable: !0,
      get: o
    });
  }, t.n = function (r) {
    var e = r && r.__esModule ? function () {
      return r.default;
    } : function () {
      return r;
    };
    return t.d(e, "a", e), e;
  }, t.o = function (r, t) {
    return Object.prototype.hasOwnProperty.call(r, t);
  }, t.p = "", t(t.s = 3);
}([function (r, t) {
  r.exports = function (r) {
    function t(o) {
      if (e[o]) return e[o].exports;
      var n = e[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return r[o].call(n.exports, n, n.exports, t), n.l = !0, n.exports;
    }

    var e = {};
    return t.m = r, t.c = e, t.d = function (r, e, o) {
      t.o(r, e) || Object.defineProperty(r, e, {
        configurable: !1,
        enumerable: !0,
        get: o
      });
    }, t.n = function (r) {
      var e = r && r.__esModule ? function () {
        return r.default;
      } : function () {
        return r;
      };
      return t.d(e, "a", e), e;
    }, t.o = function (r, t) {
      return Object.prototype.hasOwnProperty.call(r, t);
    }, t.p = "", t(t.s = 3);
  }([function (r, t, e) {
    "use strict";

    t.__esModule = !0;
    var o;
    !function (r) {
      r[r.Black = 0] = "Black", r[r.White = 1] = "White";
    }(o || (o = {})), t.default = o;
  }, function (r, t, e) {
    "use strict";

    t.__esModule = !0;
    var o = e(0),
        n = " *  *  *  *  *  *  *  *  * ",
        u = ["-FU-FU-FU-FU-FU-FU-FU-FU-FU", n, n, n, "+FU+FU+FU+FU+FU+FU+FU+FU+FU", " * +KA *  *  *  *  * +HI * ", "+KY+KE+GI+KI+OU+KI+GI+KE+KY"],
        i = [n].concat(u);
    t.PRESET = {
      HIRATE: {
        board: ["-KY-KE-GI-KI-OU-KI-GI-KE-KY", " * -HI *  *  *  *  * -KA * "].concat(u),
        turn: o.default.Black
      },
      KY: {
        board: ["-KY-KE-GI-KI-OU-KI-GI-KE * ", " * -HI *  *  *  *  * -KA * "].concat(u),
        turn: o.default.White
      },
      KY_R: {
        board: [" * -KE-GI-KI-OU-KI-GI-KE-KY", " * -HI *  *  *  *  * -KA * "].concat(u),
        turn: o.default.White
      },
      KA: {
        board: ["-KY-KE-GI-KI-OU-KI-GI-KE-KY", " * -HI *  *  *  *  *  *  * "].concat(u),
        turn: o.default.White
      },
      HI: {
        board: ["-KY-KE-GI-KI-OU-KI-GI-KE-KY", " *  *  *  *  *  *  * -KA * "].concat(u),
        turn: o.default.White
      },
      HIKY: {
        board: ["-KY-KE-GI-KI-OU-KI-GI-KE * ", " *  *  *  *  *  *  * -KA * "].concat(u),
        turn: o.default.White
      },
      2: {
        board: ["-KY-KE-GI-KI-OU-KI-GI-KE-KY"].concat(i),
        turn: o.default.White
      },
      3: {
        board: ["-KY-KE-GI-KI-OU-KI-GI-KE * "].concat(i),
        turn: o.default.White
      },
      4: {
        board: [" * -KE-GI-KI-OU-KI-GI-KE * "].concat(i),
        turn: o.default.White
      },
      5: {
        board: [" *  * -GI-KI-OU-KI-GI-KE * "].concat(i),
        turn: o.default.White
      },
      "5_L": {
        board: [" * -KE-GI-KI-OU-KI-GI *  * "].concat(i),
        turn: o.default.White
      },
      6: {
        board: [" *  * -GI-KI-OU-KI-GI *  * "].concat(i),
        turn: o.default.White
      },
      8: {
        board: [" *  *  * -KI-OU-KI *  *  * "].concat(i),
        turn: o.default.White
      },
      10: {
        board: [" *  *  *  * -OU *  *  *  * "].concat(i),
        turn: o.default.White
      }
    };
    var a = [0, -1],
        c = [0, 1],
        s = [1, 0],
        f = [-1, 0],
        l = [-1, -1],
        h = [1, -1],
        p = [-1, 1],
        d = [1, 1],
        v = {
      just: [l, a, h, f, s, c]
    };
    t.MOVE_DEF = {
      FU: {
        just: [a]
      },
      KY: {
        fly: [a]
      },
      KE: {
        just: [[-1, -2], [1, -2]]
      },
      GI: {
        just: [l, a, h, p, d]
      },
      KI: v,
      TO: v,
      NY: v,
      NK: v,
      NG: v,
      KA: {
        fly: [l, h, p, d]
      },
      HI: {
        fly: [a, f, s, c]
      },
      OU: {
        just: [l, a, h, f, s, p, c, d]
      },
      UM: {
        fly: [l, h, p, d],
        just: [a, f, s, c]
      },
      RY: {
        fly: [a, f, s, c],
        just: [l, h, p, d]
      }
    };
  }, function (r, t, e) {
    "use strict";

    t.__esModule = !0;

    var o = e(0),
        n = function () {
      function r(r) {
        this.color = "+" === r.slice(0, 1) ? o.default.Black : o.default.White, this.kind = r.slice(1);
      }

      return r.promote = function (r) {
        return {
          FU: "TO",
          KY: "NY",
          KE: "NK",
          GI: "NG",
          KA: "UM",
          HI: "RY"
        }[r] || r;
      }, r.unpromote = function (r) {
        return {
          TO: "FU",
          NY: "KY",
          NK: "KE",
          NG: "GI",
          KI: "KI",
          UM: "KA",
          RY: "HI",
          OU: "OU"
        }[r] || r;
      }, r.canPromote = function (t) {
        return r.promote(t) !== t;
      }, r.isPromoted = function (r) {
        return ["TO", "NY", "NK", "NG", "UM", "RY"].indexOf(r) >= 0;
      }, r.oppositeColor = function (r) {
        return r === o.default.Black ? o.default.White : o.default.Black;
      }, r.fromSFENString = function (t) {
        var e = "+" === t[0];
        e && (t = t.slice(1));
        var o = t.match(/[A-Z]/) ? "+" : "-",
            n = {
          P: "FU",
          L: "KY",
          N: "KE",
          S: "GI",
          G: "KI",
          B: "KA",
          R: "HI",
          K: "OU"
        }[t.toUpperCase()],
            u = new r(o + n);
        return e && u.promote(), u;
      }, r.prototype.promote = function () {
        this.kind = r.promote(this.kind);
      }, r.prototype.unpromote = function () {
        this.kind = r.unpromote(this.kind);
      }, r.prototype.inverse = function () {
        this.color = this.color === o.default.Black ? o.default.White : o.default.Black;
      }, r.prototype.toCSAString = function () {
        return (this.color === o.default.Black ? "+" : "-") + this.kind;
      }, r.prototype.toSFENString = function () {
        var t = {
          FU: "P",
          KY: "L",
          KE: "N",
          GI: "S",
          KI: "G",
          KA: "B",
          HI: "R",
          OU: "K"
        }[r.unpromote(this.kind)];
        return (r.isPromoted(this.kind) ? "+" : "") + (this.color === o.default.Black ? t : t.toLowerCase());
      }, r;
    }();

    t.default = n;
  }, function (r, t, e) {
    "use strict";

    t.__esModule = !0;
    /** @license
    * Shogi.js
    * Copyright (c) 2014 na2hiro (https://github.com/na2hiro)
    * This software is released under the MIT License.
    * http://opensource.org/licenses/mit-license.php
    */

    var o = e(0);
    t.Color = o.default;
    var n = e(1),
        u = e(2);
    t.Piece = u.default, e(4);

    var i = e(5),
        a = function () {
      function r(r) {
        this.initialize(r);
      }

      return r.getIllegalUnpromotedRow = function (r) {
        switch (r) {
          case "FU":
          case "KY":
            return 1;

          case "KE":
            return 2;

          default:
            return 0;
        }
      }, r.getRowToOppositeEnd = function (r, t) {
        return t === o.default.Black ? r : 10 - r;
      }, r.prototype.initialize = function (r) {
        void 0 === r && (r = {
          preset: "HIRATE"
        }), i.fromPreset(this, r), this.flagEditMode = !1;
      }, r.prototype.initializeFromSFENString = function (r) {
        i.fromSfen(this, r);
      }, r.prototype.toCSAString = function () {
        return i.toCSA(this);
      }, r.prototype.toSFENString = function (r) {
        return void 0 === r && (r = 1), i.toSfen(this, r);
      }, r.prototype.editMode = function (r) {
        this.flagEditMode = r;
      }, r.prototype.move = function (t, e, o, n, u) {
        void 0 === u && (u = !1);
        var i = this.get(t, e);
        if (null == i) throw new Error("no piece found at " + t + ", " + e);
        if (this.checkTurn(i.color), !this.flagEditMode && !this.getMovesFrom(t, e).some(function (r) {
          return r.to.x === o && r.to.y === n;
        })) throw new Error("cannot move from " + t + ", " + e + " to " + o + ", " + n);
        null != this.get(o, n) && this.capture(o, n);
        var a = r.getIllegalUnpromotedRow(i.kind) >= r.getRowToOppositeEnd(n, i.color);
        (u || a) && i.promote(), this.set(o, n, i), this.set(t, e, null), this.nextTurn();
      }, r.prototype.unmove = function (r, t, e, o, n, i) {
        void 0 === n && (n = !1);
        var a = this.get(e, o);
        if (null == a) throw new Error("no piece found at " + e + ", " + o);
        this.checkTurn(u.default.oppositeColor(a.color));
        var c;
        i && (c = this.popFromHand(u.default.unpromote(i), a.color), c.inverse());
        var s = this.flagEditMode;
        this.editMode(!0), this.move(e, o, r, t), n && a.unpromote(), i && (u.default.isPromoted(i) && c.promote(), this.set(e, o, c)), this.editMode(s), this.prevTurn();
      }, r.prototype.drop = function (r, t, e, o) {
        if (void 0 === o && (o = this.turn), this.checkTurn(o), null != this.get(r, t)) throw new Error("there is a piece at " + r + ", " + t);
        if (!this.getDropsBy(o).some(function (o) {
          return o.to.x === r && o.to.y === t && o.kind === e;
        })) throw new Error("Cannot move");
        var n = this.popFromHand(e, o);
        this.set(r, t, n), this.nextTurn();
      }, r.prototype.undrop = function (r, t) {
        var e = this.get(r, t);
        if (null == e) throw new Error("there is no piece at " + r + ", " + t);
        this.checkTurn(u.default.oppositeColor(e.color)), this.pushToHand(e), this.set(r, t, null), this.prevTurn();
      }, r.prototype.getMovesFrom = function (r, t) {
        var e = function (r, t, e) {
          if (r < 1 || 9 < r || t < 1 || 9 < t) return !1;
          var o = this.get(r, t);
          return null == o || o.color !== e;
        }.bind(this),
            u = function (r, t, e) {
          var o = this.get(r, t);
          return null != o && o.color !== e;
        }.bind(this),
            i = this.get(r, t);

        if (null == i) return [];
        var a = n.MOVE_DEF[i.kind],
            c = [],
            s = {
          x: r,
          y: t
        },
            f = i.color === o.default.Black ? 1 : -1;
        if (a.just) for (var l = 0, h = a.just; l < h.length; l++) {
          var p = h[l],
              d = {
            x: s.x + p[0] * f,
            y: s.y + p[1] * f
          };
          e(d.x, d.y, i.color) && c.push({
            from: s,
            to: d
          });
        }
        if (a.fly) for (var v = 0, m = a.fly; v < m.length; v++) {
          for (var p = m[v], d = {
            x: s.x + p[0] * f,
            y: s.y + p[1] * f
          }; e(d.x, d.y, i.color) && (c.push({
            from: s,
            to: {
              x: d.x,
              y: d.y
            }
          }), !u(d.x, d.y, i.color));) {
            d.x += p[0] * f, d.y += p[1] * f;
          }
        }
        return c;
      }, r.prototype.getDropsBy = function (t) {
        for (var e = [], o = [], n = [], u = 1; u <= 9; u++) {
          for (var i = !1, a = 1; a <= 9; a++) {
            var c = this.get(u, a);
            null == c ? o.push({
              x: u,
              y: a
            }) : c.color === t && "FU" === c.kind && (i = !0);
          }

          n.push(i);
        }

        for (var s = {}, f = 0, l = this.hands[t]; f < l.length; f++) {
          var h = l[f],
              p = h.kind;

          if (!s[p]) {
            s[p] = !0;

            for (var d = r.getIllegalUnpromotedRow(p), v = 0, m = o; v < m.length; v++) {
              var A = m[v];
              "FU" === p && n[A.x - 1] || d >= r.getRowToOppositeEnd(A.y, t) || e.push({
                to: A,
                color: t,
                kind: p
              });
            }
          }
        }

        return e;
      }, r.prototype.getMovesTo = function (r, t, e, o) {
        void 0 === o && (o = this.turn);

        for (var n = {
          x: r,
          y: t
        }, u = [], i = 1; i <= 9; i++) {
          for (var a = 1; a <= 9; a++) {
            var c = this.get(i, a);

            if (c && c.kind === e && c.color === o) {
              var s = this.getMovesFrom(i, a);
              s.some(function (e) {
                return e.to.x === r && e.to.y === t;
              }) && u.push({
                from: {
                  x: i,
                  y: a
                },
                to: n
              });
            }
          }
        }

        return u;
      }, r.prototype.get = function (r, t) {
        return this.board[r - 1][t - 1];
      }, r.prototype.getHandsSummary = function (r) {
        for (var t = {
          FU: 0,
          KY: 0,
          KE: 0,
          GI: 0,
          KI: 0,
          KA: 0,
          HI: 0
        }, e = 0, o = this.hands[r]; e < o.length; e++) {
          t[o[e].kind]++;
        }

        return t;
      }, r.prototype.captureByColor = function (r, t, e) {
        if (!this.flagEditMode) throw new Error("cannot edit board without editMode");
        var o = this.get(r, t);
        this.set(r, t, null), o.unpromote(), o.color !== e && o.inverse(), this.pushToHand(o);
      }, r.prototype.flip = function (r, t) {
        if (!this.flagEditMode) throw new Error("cannot edit board without editMode");
        var e = this.get(r, t);
        return !!e && (u.default.isPromoted(e.kind) ? (e.unpromote(), e.inverse()) : u.default.canPromote(e.kind) ? e.promote() : e.inverse(), !0);
      }, r.prototype.setTurn = function (r) {
        if (!this.flagEditMode) throw new Error("cannot set turn without editMode");
        this.turn = r;
      }, r.prototype.set = function (r, t, e) {
        this.board[r - 1][t - 1] = e;
      }, r.prototype.capture = function (r, t) {
        var e = this.get(r, t);
        this.set(r, t, null), e.unpromote(), e.inverse(), this.pushToHand(e);
      }, r.prototype.pushToHand = function (r) {
        this.hands[r.color].push(r);
      }, r.prototype.popFromHand = function (r, t) {
        for (var e = this.hands[t], o = 0; o < e.length; o++) {
          if (e[o].kind === r) {
            var n = e[o];
            return e.splice(o, 1), n;
          }
        }

        throw new Error(t + " has no " + r);
      }, r.prototype.nextTurn = function () {
        this.flagEditMode || (this.turn = this.turn === o.default.Black ? o.default.White : o.default.Black);
      }, r.prototype.prevTurn = function () {
        this.flagEditMode || this.nextTurn();
      }, r.prototype.checkTurn = function (r) {
        if (!this.flagEditMode && r !== this.turn) throw new Error("cannot move opposite piece");
      }, r;
    }();

    t.Shogi = a;
  }, function (r, t, e) {
    "use strict";

    t.__esModule = !0, Array.prototype.some || (Array.prototype.some = function (r) {
      if (null == this) throw new TypeError();
      var t = Object(this),
          e = t.length >>> 0;
      if ("function" != typeof r) throw new TypeError();

      for (var o = arguments[1], n = 0; n < e; n++) {
        if (n in t && r.call(o, t[n], n, t)) return !0;
      }

      return !1;
    });
  }, function (r, t, e) {
    "use strict";

    function o(r, t) {
      var e,
          o = [],
          n = [[], []];

      if ("OTHER" !== t.preset) {
        for (var u = 0; u < 9; u++) {
          o[u] = [];

          for (var i = 0; i < 9; i++) {
            var f = c.PRESET[t.preset].board[i].slice(24 - 3 * u, 24 - 3 * u + 3);
            o[u][i] = " * " === f ? null : new s.default(f);
          }
        }

        e = c.PRESET[t.preset].turn;
      } else {
        for (var u = 0; u < 9; u++) {
          o[u] = [];

          for (var i = 0; i < 9; i++) {
            var l = t.data.board[u][i];
            o[u][i] = l.kind ? new s.default((l.color === a.default.Black ? "+" : "-") + l.kind) : null;
          }
        }

        e = t.data.color;

        for (var h = 0; h < 2; h++) {
          for (var p in t.data.hands[h]) {
            if (t.data.hands[h].hasOwnProperty(p)) for (var f = (0 === h ? "+" : "-") + p, u = 0; u < t.data.hands[h][p]; u++) {
              n[h].push(new s.default(f));
            }
          }
        }
      }

      r.board = o, r.turn = e, r.hands = n;
    }

    function n(r) {
      for (var t = [], e = 0; e < 9; e++) {
        for (var o = "P" + (e + 1), n = 8; n >= 0; n--) {
          var u = r.board[n][e];
          o += null == u ? " * " : u.toCSAString();
        }

        t.push(o);
      }

      for (var i = 0; i < 2; i++) {
        for (var o = "P" + "+-"[i], c = 0, s = r.hands[i]; c < s.length; c++) {
          o += "00" + s[c].kind;
        }

        t.push(o);
      }

      return t.push(r.turn === a.default.Black ? "+" : "-"), t.join("\n");
    }

    function u(r, t) {
      for (var e = [], o = 0; o < 9; o++) {
        e[o] = [];

        for (var n = 0; n < 9; n++) {
          e[o][n] = null;
        }
      }

      for (var u = t.split(" "), i = u[0], c = 8, f = 0, o = 0; o < i.length; o++) {
        var l = i[o];
        "+" === l && (o++, l += i[o]), l.match(/^[1-9]$/) ? c -= Number(l) : "/" === l ? (f++, c = 8) : (e[c][f] = s.default.fromSFENString(l), c--);
      }

      r.board = e, r.turn = "b" === u[1] ? a.default.Black : a.default.White;
      var h = [[], []],
          p = u[2];
      if ("-" !== p) for (; p.length > 0;) {
        var d = 1,
            v = p.match(/^[0-9]+/);
        v && (d = Number(v[0]), p = p.slice(v[0].length));

        for (var o = 0; o < d; o++) {
          var m = s.default.fromSFENString(p[0]);
          h[m.color].push(m);
        }

        p = p.slice(1);
      }
      r.hands = h;
    }

    function i(r, t) {
      for (var e = [], o = [], n = 0; n < 9; n++) {
        for (var u = "", i = 0, c = 8; c >= 0; c--) {
          var s = r.board[c][n];
          null == s ? i++ : (i > 0 && (u += "" + i, i = 0), u += s.toSFENString());
        }

        i > 0 && (u += "" + i), o.push(u);
      }

      if (e.push(o.join("/")), e.push(r.turn === a.default.Black ? "b" : "w"), 0 === r.hands[0].length && 0 === r.hands[1].length) e.push("-");else {
        for (var f = "", l = ["R", "B", "G", "S", "N", "L", "P", "r", "b", "g", "s", "n", "l", "p"], h = {}, p = 0; p < 2; p++) {
          for (var d = 0, v = r.hands[p]; d < v.length; d++) {
            var m = v[d],
                A = m.toSFENString();
            h[A] = (h[A] || 0) + 1;
          }
        }

        for (var g = 0, k = l; g < k.length; g++) {
          var y = k[g];
          h[y] > 0 && (f += (h[y] > 1 ? h[y] : "") + y);
        }

        e.push(f);
      }
      return e.push("" + t), e.join(" ");
    }

    t.__esModule = !0;
    var a = e(0),
        c = e(1),
        s = e(2);
    t.fromPreset = o, t.toCSA = n, t.fromSfen = u, t.toSfen = i;
  }]);
}, function (r, t, e) {
  "use strict";

  function o(r, t) {
    return t === F.Color.Black ? r.y <= 3 : r.y >= 7;
  }

  function n(r) {
    return u(new F.Shogi(r.initial || void 0), r.moves), r;
  }

  function u(r, t, e) {
    for (var n = 0; n < t.length; n++) {
      var i = 0 === n ? e : t[n - 1],
          a = t[n].move;
      if (a) if (a.color = r.turn, a.from) {
        i && i.move && a.to.x === i.move.to.x && a.to.y === i.move.to.y && (a.same = !0), h(r, a), a.piece || (a.piece = r.get(a.from.x, a.from.y).kind), a.promote || F.Piece.isPromoted(a.piece) || !F.Piece.canPromote(a.piece) || (o(a.to, r.turn) || o(a.from, r.turn)) && (a.promote = !1), l(r, a);

        try {
          r.move(a.from.x, a.from.y, a.to.x, a.to.y, a.promote);
        } catch (r) {
          throw new Error(n + "手目で失敗しました: " + r);
        }
      } else r.getMovesTo(a.to.x, a.to.y, a.piece).length > 0 && (a.relative = "H"), r.drop(a.to.x, a.to.y, a.piece);
    }

    I(t, r);

    for (var n = t.length - 1; n >= 0; n--) {
      var a = t[n].move;
      a && (a.from ? r.unmove(a.from.x, a.from.y, a.to.x, a.to.y, a.promote, a.capture) : r.undrop(a.to.x, a.to.y));
      var i = n <= 1 ? e : t[n - 1];
      if (t[n].forks) for (var c = 0, s = t[n].forks; c < s.length; c++) {
        var f = s[c];
        u(r, f, i);
      }
    }
  }

  function i(r) {
    return r.initial && "HIRATE" === r.initial.preset && r.initial.data && (r.initial.preset = "OTHER"), a(new F.Shogi(r.initial || void 0), r.moves), r;
  }

  function a(r, t, e) {
    for (var n = 0; n < t.length; n++) {
      var u = 0 === n ? e : t[n - 1],
          i = t[n].move;
      if (i) if (i.color = r.turn, i.from) {
        i.same && (i.to = u.move.to), h(r, i), i.promote || F.Piece.isPromoted(i.piece) || !F.Piece.canPromote(i.piece) || (o(i.to, r.turn) || o(i.from, r.turn)) && (i.promote = !1), l(r, i);

        try {
          r.move(i.from.x, i.from.y, i.to.x, i.to.y, i.promote);
        } catch (r) {
          throw new Error(n + "手目で失敗しました: " + r);
        }
      } else r.getMovesTo(i.to.x, i.to.y, i.piece).length > 0 && (i.relative = "H"), r.drop(i.to.x, i.to.y, i.piece);
    }

    I(t, r);

    for (var n = t.length - 1; n >= 0; n--) {
      var i = t[n].move;
      i && (i.from ? r.unmove(i.from.x, i.from.y, i.to.x, i.to.y, i.promote, i.capture) : r.undrop(i.to.x, i.to.y));
      var u = 0 === n ? e : t[n - 1];
      if (t[n].forks) for (var c = 0, s = t[n].forks; c < s.length; c++) {
        var f = s[c];
        a(r, f, u);
      }
    }
  }

  function c(r) {
    return s(new F.Shogi(r.initial || void 0), r.moves), r;
  }

  function s(r, t, e) {
    for (var o = 0; o < t.length; o++) {
      var n = 0 === o ? e : t[o - 1],
          u = t[o].move;

      if (u) {
        u.color = r.turn, u.same && (u.to = n.move.to);
        var i = r.getMovesTo(u.to.x, u.to.y, u.piece);
        if ("H" === u.relative || 0 === i.length) ;else if (1 === i.length) u.from = i[0].from;else {
          var a = g(u.relative, r.turn, i);
          if (1 !== a.length) throw new Error("相対情報が不完全で複数の候補があります");
          u.from = a[0].from;
        }

        if (u.from) {
          h(r, u);

          try {
            r.move(u.from.x, u.from.y, u.to.x, u.to.y, u.promote);
          } catch (r) {
            throw new Error(o + "手目で失敗しました: " + r);
          }
        } else r.drop(u.to.x, u.to.y, u.piece);
      }
    }

    I(t, r);

    for (var o = t.length - 1; o >= 0; o--) {
      var u = t[o].move;

      if (u) {
        u.from ? r.unmove(u.from.x, u.from.y, u.to.x, u.to.y, u.promote, u.capture) : r.undrop(u.to.x, u.to.y);
        var n = o <= 1 ? e : t[o - 1];
        if (t[o].forks) for (var c = 0, f = t[o].forks; c < f.length; c++) {
          var l = f[c];
          s(r, l, n);
        }
      }
    }
  }

  function f(r) {
    y(r);

    for (var t = new F.Shogi(r.initial || void 0), e = 0; e < r.moves.length; e++) {
      C(r.moves[e].time, e >= 2 ? r.moves[e - 2].time : void 0);
      var n = r.moves[e].move;
      if (n) if (n.color = t.turn, n.from) {
        if (e > 0 && r.moves[e - 1].move && r.moves[e - 1].move.to.x === n.to.x && r.moves[e - 1].move.to.y === n.to.y && (n.same = !0), h(t, n), F.Piece.isPromoted(n.piece)) {
          var u = t.get(n.from.x, n.from.y);
          u.kind !== n.piece && (n.piece = u.kind, n.promote = !0);
        } else F.Piece.canPromote(n.piece) && (o(n.to, t.turn) || o(n.from, t.turn)) && (n.promote = !1);

        l(t, n);

        try {
          t.move(n.from.x, n.from.y, n.to.x, n.to.y, n.promote);
        } catch (r) {
          throw new Error(e + "手目で失敗しました: " + r);
        }
      } else t.getMovesTo(n.to.x, n.to.y, n.piece).length > 0 && (n.relative = "H"), t.drop(n.to.x, n.to.y, n.piece);
    }

    return r;
  }

  function l(r, t) {
    var e = r.getMovesTo(t.to.x, t.to.y, t.piece).map(function (t) {
      return p(r.turn, v(t.to, t.from));
    });

    if (e.length >= 2) {
      var o = p(r.turn, v(t.to, t.from));

      t.relative = function () {
        return 1 === e.filter(function (r) {
          return r.y === o.y;
        }).length ? m(o.y) : 1 === e.filter(function (r) {
          return r.x === o.x;
        }).length ? A("UM" !== t.piece && "RY" !== t.piece || 0 !== o.x ? o.x : 0 === e.filter(function (r) {
          return r.x < 0;
        }).length ? -1 : 1) : A(o.x) + m(o.y);
      }();
    }
  }

  function h(r, t) {
    var e = r.get(t.to.x, t.to.y);
    e && (t.capture = e.kind);
  }

  function p(r, t) {
    return r === F.Color.Black ? t : {
      x: -t.x,
      y: -t.y
    };
  }

  function d(r, t) {
    return r === t ? 0 : r > t ? 1 : -1;
  }

  function v(r, t) {
    return {
      x: d(r.x, t.x),
      y: d(r.y, t.y)
    };
  }

  function m(r) {
    return 0 === r ? "M" : r > 0 ? "D" : "U";
  }

  function A(r) {
    return 0 === r ? "C" : r > 0 ? "R" : "L";
  }

  function g(r, t, e) {
    for (var o = [], n = 0, u = e; n < u.length; n++) {
      var i = u[n];
      !function (e) {
        r.split("").every(function (r) {
          return k(r, t, e);
        }) && o.push(e);
      }(i);
    }

    return o;
  }

  function k(r, t, e) {
    var o = p(t, {
      x: e.to.x - e.from.x,
      y: e.to.y - e.from.y
    });

    switch (r) {
      case "U":
        return o.y < 0;

      case "M":
        return 0 === o.y;

      case "D":
        return o.y > 0;

      case "L":
        return o.x < 0;

      case "C":
        return 0 === o.x;

      case "R":
        return o.x > 0;
    }
  }

  function y(r) {
    if (r.initial && "OTHER" === r.initial.preset) {
      for (var t = ["FU", "KY", "KE", "GI", "KI", "KA", "HI"], e = 0; e < 2; e++) {
        for (var o = 0, n = t; o < n.length; o++) {
          var u = n[o];
          if (0 !== r.initial.data.hands[e][u]) return;
        }
      }

      for (var i = [[{
        color: F.Color.White,
        kind: "KY"
      }, {}, {
        color: F.Color.White,
        kind: "FU"
      }, {}, {}, {}, {
        color: F.Color.Black,
        kind: "FU"
      }, {}, {
        color: F.Color.Black,
        kind: "KY"
      }], [{
        color: F.Color.White,
        kind: "KE"
      }, {
        color: F.Color.White,
        kind: "KA"
      }, {
        color: F.Color.White,
        kind: "FU"
      }, {}, {}, {}, {
        color: F.Color.Black,
        kind: "FU"
      }, {
        color: F.Color.Black,
        kind: "HI"
      }, {
        color: F.Color.Black,
        kind: "KE"
      }], [{
        color: F.Color.White,
        kind: "GI"
      }, {}, {
        color: F.Color.White,
        kind: "FU"
      }, {}, {}, {}, {
        color: F.Color.Black,
        kind: "FU"
      }, {}, {
        color: F.Color.Black,
        kind: "GI"
      }], [{
        color: F.Color.White,
        kind: "KI"
      }, {}, {
        color: F.Color.White,
        kind: "FU"
      }, {}, {}, {}, {
        color: F.Color.Black,
        kind: "FU"
      }, {}, {
        color: F.Color.Black,
        kind: "KI"
      }], [{
        color: F.Color.White,
        kind: "OU"
      }, {}, {
        color: F.Color.White,
        kind: "FU"
      }, {}, {}, {}, {
        color: F.Color.Black,
        kind: "FU"
      }, {}, {
        color: F.Color.Black,
        kind: "OU"
      }], [{
        color: F.Color.White,
        kind: "KI"
      }, {}, {
        color: F.Color.White,
        kind: "FU"
      }, {}, {}, {}, {
        color: F.Color.Black,
        kind: "FU"
      }, {}, {
        color: F.Color.Black,
        kind: "KI"
      }], [{
        color: F.Color.White,
        kind: "GI"
      }, {}, {
        color: F.Color.White,
        kind: "FU"
      }, {}, {}, {}, {
        color: F.Color.Black,
        kind: "FU"
      }, {}, {
        color: F.Color.Black,
        kind: "GI"
      }], [{
        color: F.Color.White,
        kind: "KE"
      }, {
        color: F.Color.White,
        kind: "HI"
      }, {
        color: F.Color.White,
        kind: "FU"
      }, {}, {}, {}, {
        color: F.Color.Black,
        kind: "FU"
      }, {
        color: F.Color.Black,
        kind: "KA"
      }, {
        color: F.Color.Black,
        kind: "KE"
      }], [{
        color: F.Color.White,
        kind: "KY"
      }, {}, {
        color: F.Color.White,
        kind: "FU"
      }, {}, {}, {}, {
        color: F.Color.Black,
        kind: "FU"
      }, {}, {
        color: F.Color.Black,
        kind: "KY"
      }]], a = [], e = 0; e < 9; e++) {
        for (var c = 0; c < 9; c++) {
          K(r.initial.data.board[e][c], i[e][c]) || a.push("" + (e + 1) + (c + 1));
        }
      }

      var s = {};
      s[""] = "HIRATE", s[11] = "KY", s[91] = "KY_R", s[22] = "KA", s[82] = "HI", s[1182] = "HIKY", s[2282] = "2", s[228291] = "3", s[11228291] = "4", s[1122818291] = "5", s[1121228291] = "5_L", s[112122818291] = "6", s[0x3fbbf1cdec333] = "8", s["11212231416171818291"] = "10";
      var f = s[a.sort().join("")];
      "HIRATE" === f ? r.initial.data.color === F.Color.Black && (r.initial.preset = "HIRATE", delete r.initial.data) : f && r.initial.data.color === F.Color.White && (r.initial.preset = f, delete r.initial.data);
    }
  }

  function K(r, t) {
    return void 0 === r.color && void 0 === t.color || void 0 !== r.color && void 0 !== t.color && r.color === t.color && r.kind === t.kind;
  }

  function I(r, t) {
    r.length >= 1 && "ILLEGAL_ACTION" === r[r.length - 1].special && (r[r.length - 1].special = (t.turn ? "+" : "-") + "ILLEGAL_ACTION");
  }

  function C(r, t) {
    void 0 === t && (t = {
      now: {
        m: 0,
        s: 0
      },
      total: {
        h: 0,
        m: 0,
        s: 0
      }
    }), r && (r.total = {
      h: (r.now.h || 0) + t.total.h,
      m: r.now.m + t.total.m,
      s: r.now.s + t.total.s
    }, r.total.m += Math.floor(r.total.s / 60), r.total.s = r.total.s % 60, r.total.h += Math.floor(r.total.m / 60), r.total.m = r.total.m % 60);
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  /** @license
  * JSON Kifu Format
  * Copyright (c) 2014 na2hiro (https://github.com/na2hiro)
  * This software is released under the MIT License.
  * http://opensource.org/licenses/mit-license.php
  */

  var F = e(0);
  t.canPromote = o, t.normalizeMinimal = n, t.normalizeKIF = i, t.normalizeKI2 = c, t.normalizeCSA = f;
}, function (r, t, e) {
  "use strict";

  function o(r) {
    return i.parse(r);
  }

  function n(r) {
    return c.parse(r);
  }

  function u(r) {
    return a.parse(r);
  }

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), e(6);
  var i = e(7),
      a = e(8),
      c = e(9);
  t.parseCSA = o, t.parseKIF = n, t.parseKI2 = u;
}, function (r, t, e) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var o = e(4);
  t.Formats = o;
  var n = e(5);
  t.JKFPlayer = n.default;
  var u = e(1);
  t.Normalizer = u;
  var i = e(2);
  t.Parsers = i;
}, function (r, t, e) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
}, function (r, t, e) {
  "use strict";
  /** @license
  * JSON Kifu Format
  * Copyright (c) 2014 na2hiro (https://github.com/na2hiro)
  * This software is released under the MIT License.
  * http://opensource.org/licenses/mit-license.php
  */

  Object.defineProperty(t, "__esModule", {
    value: !0
  });

  var o = e(0),
      n = e(1),
      u = e(2),
      i = function () {
    function r(r) {
      this.forkPointers = [], this.forks_ = null, this.currentStream_ = null, this.shogi = new o.Shogi(r.initial || void 0), this.initialize(r);
    }

    return r.log = function () {
      for (var t = [], e = 0; e < arguments.length; e++) {
        t[e] = arguments[e];
      }

      r.debug ? console.log(t) : r.logs.push(t);
    }, r.parse = function (t, e) {
      if (e) {
        var o = e.split(".");

        switch (o[o.length - 1].toLowerCase()) {
          case "jkf":
            return r.parseJKF(t);

          case "kif":
          case "kifu":
            return r.parseKIF(t);

          case "ki2":
          case "ki2u":
            return r.parseKI2(t);

          case "csa":
            return r.parseCSA(t);
        }
      }

      try {
        return r.parseJKF(t);
      } catch (t) {
        r.log("failed to parse as jkf", t);
      }

      try {
        return r.parseKIF(t);
      } catch (t) {
        r.log("failed to parse as kif", t);
      }

      try {
        return r.parseKI2(t);
      } catch (t) {
        r.log("failed to parse as ki2", t);
      }

      try {
        return r.parseCSA(t);
      } catch (t) {
        r.log("failed to parse as csa", t);
      }

      throw new Error("JKF, KIF, KI2, CSAいずれの形式でも失敗しました");
    }, r.parseJKF = function (t) {
      return r.log("parseJKF", t), new r(JSON.parse(t));
    }, r.parseKIF = function (t) {
      return r.log("parseKIF", t), new r(n.normalizeKIF(u.parseKIF(r.addLastNewLine(t))));
    }, r.parseKI2 = function (t) {
      return r.log("parseKI2", t), new r(n.normalizeKI2(u.parseKI2(r.addLastNewLine(t))));
    }, r.parseCSA = function (t) {
      return r.log("parseCSA", t), new r(n.normalizeCSA(u.parseCSA(r.addLastNewLine(t))));
    }, r.addLastNewLine = function (r) {
      return "\n" === r.substr(r.length - 1) ? r : r + "\n";
    }, r.numToZen = function (r) {
      return "０１２３４５６７８９"[r];
    }, r.numToKan = function (r) {
      return "〇一二三四五六七八九"[r];
    }, r.kindToKan = function (r) {
      return {
        FU: "歩",
        KY: "香",
        KE: "桂",
        GI: "銀",
        KI: "金",
        KA: "角",
        HI: "飛",
        OU: "玉",
        TO: "と",
        NY: "成香",
        NK: "成桂",
        NG: "成銀",
        UM: "馬",
        RY: "龍"
      }[r];
    }, r.relativeToKan = function (r) {
      return {
        L: "左",
        C: "直",
        R: "右",
        U: "上",
        M: "寄",
        D: "引",
        H: "打"
      }[r];
    }, r.specialToKan = function (r) {
      return {
        TORYO: "投了",
        CHUDAN: "中断",
        SENNICHITE: "千日手",
        TIME_UP: "時間切れ",
        ILLEGAL_MOVE: "反則負け",
        "+ILLEGAL_ACTION": "後手反則負け",
        "-ILLEGAL_ACTION": "先手反則負け",
        JISHOGI: "持将棋",
        KACHI: "勝ち宣言",
        HIKIWAKE: "引き分け宣言",
        MATTA: "待った",
        TSUMI: "詰",
        FUZUMI: "不詰",
        ERROR: "エラー"
      }[r] || r;
    }, r.moveToReadableKifu = function (t) {
      if (t.special) return r.specialToKan(t.special);
      var e = t.move,
          n = e.color === o.Color.Black ? "☗" : "☖";
      return e.same ? n += "同　" : n += r.numToZen(e.to.x) + r.numToKan(e.to.y), n += r.kindToKan(e.piece), e.relative && (n += e.relative.split("").map(r.relativeToKan).join("")), null != e.promote && (n += e.promote ? "成" : "不成"), n;
    }, r.doMove = function (r, t) {
      t && (t.from ? r.move(t.from.x, t.from.y, t.to.x, t.to.y, t.promote) : r.drop(t.to.x, t.to.y, t.piece, void 0 !== t.color ? t.color : void 0));
    }, r.undoMove = function (r, t) {
      t && (t.from ? r.unmove(t.from.x, t.from.y, t.to.x, t.to.y, t.promote, t.capture) : r.undrop(t.to.x, t.to.y));
    }, r.getState = function (t) {
      return {
        board: r.getBoardState(t),
        color: t.turn,
        hands: r.getHandsState(t)
      };
    }, r.sameMoveMinimal = function (r, t) {
      return r.to.x === t.to.x && r.to.y === t.to.y && (r.from && t.from ? r.from.x === t.from.x && r.from.y === t.from.y && r.promote === t.promote : r.piece === t.piece);
    }, r.getBoardState = function (r) {
      for (var t = [], e = 1; e <= 9; e++) {
        for (var o = [], n = 1; n <= 9; n++) {
          var u = r.get(e, n);
          o.push(u ? {
            color: u.color,
            kind: u.kind
          } : {});
        }

        t.push(o);
      }

      return t;
    }, r.getHandsState = function (r) {
      return [r.getHandsSummary(o.Color.Black), r.getHandsSummary(o.Color.White)];
    }, Object.defineProperty(r.prototype, "forks", {
      get: function get() {
        return null === this.forks_ && this.updateForksAndCurrentStream(), this.forks_;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(r.prototype, "currentStream", {
      get: function get() {
        return null === this.currentStream_ && this.updateForksAndCurrentStream(), this.currentStream_;
      },
      enumerable: !0,
      configurable: !0
    }), r.prototype.initialize = function (r) {
      this.kifu = r, this.tesuu = 0, this.forkPointers = [];
    }, r.prototype.forward = function () {
      var t = this.getMoveFormat(this.tesuu + 1);
      if (!t) return !1;
      this.tesuu++;
      var e = t.move;
      return !e || (r.log("forward", this.tesuu, e), this.doMove(e), !0);
    }, r.prototype.backward = function () {
      var t = this;
      if (this.tesuu <= 0) return !1;
      var e = this.getMoveFormat(this.tesuu).move;
      return r.log("backward", this.tesuu - 1, e), this.undoMove(e), this.tesuu--, this.forkPointers = this.forkPointers.filter(function (r) {
        return r.te <= t.tesuu;
      }), this.updateForksAndCurrentStream(), !0;
    }, r.prototype.goto = function (r) {
      if ("string" == typeof r && (r = Number(r)), !isNaN(r)) {
        var t = 1e4;
        if (this.tesuu < r) for (; this.tesuu !== r && this.forward() && t-- > 0;) {
          ;
        } else for (; this.tesuu !== r && this.backward() && t-- > 0;) {
          ;
        }
        if (0 === t) throw new Error("tesuu overflows");
      }
    }, r.prototype.go = function (r) {
      "string" == typeof r && (r = Number(r)), isNaN(r) || this.goto(this.tesuu + r);
    }, r.prototype.forkAndForward = function (r) {
      "string" == typeof r && (r = parseInt(r, 10));
      var t = this.getMoveFormat(this.tesuu + 1).forks;
      return !(!t || t.length <= r) && (this.forkPointers.push({
        te: this.tesuu + 1,
        forkIndex: r
      }), this.updateForksAndCurrentStream(), this.forward());
    }, r.prototype.inputMove = function (t) {
      if (this.getMoveFormat().special) throw new Error("終了局面へ棋譜を追加することは出来ません");

      if (null != t.from && null == t.promote) {
        var e = this.shogi.get(t.from.x, t.from.y);
        if (!o.Piece.isPromoted(e.kind) && o.Piece.canPromote(e.kind) && (n.canPromote(t.from, e.color) || n.canPromote(t.to, e.color))) return !1;
      }

      var u = this.getMoveFormat(this.tesuu + 1);

      if (u) {
        if (u.move && r.sameMoveMinimal(u.move, t)) return this.forward(), !0;
        if (u.forks) for (var i = 0; i < u.forks.length; i++) {
          var a = u.forks[i][0];
          if (a && a.move && r.sameMoveMinimal(a.move, t)) return this.forkAndForward(i), !0;
        }
      }

      this.doMove(t);
      var c,
          s = {
        move: t
      },
          f = this.tesuu < this.getMaxTesuu();
      return f ? (c = this.getMoveFormat(this.tesuu + 1), c.forks || (c.forks = []), c.forks.push([s])) : this.forks[this.forks.length - 1].moves.push(s), this.updateForksAndCurrentStream(), n.normalizeMinimal(this.kifu), this.undoMove(t), f ? this.forkAndForward(c.forks.length - 1) : this.forward(), !0;
    }, r.prototype.getBoard = function (r, t) {
      return this.shogi.get(r, t);
    }, r.prototype.getComments = function (r) {
      return void 0 === r && (r = this.tesuu), this.getMoveFormat(r).comments || [];
    }, r.prototype.getMove = function (r) {
      return void 0 === r && (r = this.tesuu), this.getMoveFormat(r).move;
    }, r.prototype.getReadableKifu = function (t) {
      return void 0 === t && (t = this.tesuu), 0 === t ? "開始局面" : r.moveToReadableKifu(this.getMoveFormat(t));
    }, r.prototype.getReadableForkKifu = function (t) {
      return void 0 === t && (t = this.tesuu), this.getNextFork(t).map(function (t) {
        return r.moveToReadableKifu(t[0]);
      });
    }, r.prototype.getMaxTesuu = function () {
      return this.currentStream.length - 1;
    }, r.prototype.toJKF = function () {
      return JSON.stringify(this.kifu);
    }, r.prototype.getState = function () {
      return r.getState(this.shogi);
    }, r.prototype.getReadableKifuState = function () {
      for (var r = [], t = 0; t <= this.getMaxTesuu(); t++) {
        r.push({
          comments: this.getComments(t),
          forks: this.getReadableForkKifu(t - 1),
          kifu: this.getReadableKifu(t)
        });
      }

      return r;
    }, r.prototype.updateForksAndCurrentStream = function () {
      for (var r = [], t = [], e = this.kifu.moves, o = 0, n = 0, u = this.forkPointers; n < u.length; n++) {
        var i = u[n];
        r.push({
          te: o,
          moves: e
        }), t = t.concat(e.slice(0, i.te - o)), e = e[i.te - o].forks[i.forkIndex], o = i.te;
      }

      r.push({
        te: o,
        moves: e
      }), this.forks_ = r, this.currentStream_ = t.concat(e.slice());
    }, r.prototype.getMoveFormat = function (r) {
      return void 0 === r && (r = this.tesuu), this.currentStream[r];
    }, r.prototype.getNextFork = function (r) {
      void 0 === r && (r = this.tesuu);
      var t = this.getMoveFormat(r + 1);
      return t && t.forks ? t.forks : [];
    }, r.prototype.doMove = function (t) {
      r.doMove(this.shogi, t);
    }, r.prototype.undoMove = function (t) {
      r.undoMove(this.shogi, t);
    }, r.debug = !1, r.logs = [], r;
  }();

  t.default = i;
}, function (r, t) {}, function (r, t, e) {
  "use strict";

  function o(r, t, e, n) {
    this.message = r, this.expected = t, this.found = e, this.location = n, this.name = "SyntaxError", "function" == typeof Error.captureStackTrace && Error.captureStackTrace(this, o);
  }

  function n(r, t) {
    function e(r, t) {
      return {
        type: "literal",
        text: r,
        ignoreCase: t
      };
    }

    function n(r, t, e) {
      return {
        type: "class",
        parts: r,
        inverted: t,
        ignoreCase: e
      };
    }

    function u(r) {
      return {
        type: "other",
        description: r
      };
    }

    function i(t) {
      var e,
          o = kt[t];
      if (o) return o;

      for (e = t - 1; !kt[e];) {
        e--;
      }

      for (o = kt[e], o = {
        line: o.line,
        column: o.column
      }; e < t;) {
        10 === r.charCodeAt(e) ? (o.line++, o.column = 1) : o.column++, e++;
      }

      return kt[t] = o, o;
    }

    function a(r, t) {
      var e = i(r),
          o = i(t);
      return {
        start: {
          offset: r,
          line: e.line,
          column: e.column
        },
        end: {
          offset: t,
          line: o.line,
          column: o.column
        }
      };
    }

    function c(r) {
      At < yt || (At > yt && (yt = At, Kt = []), Kt.push(r));
    }

    function s(r, t, e) {
      return new o(o.buildMessage(r, t), r, t, e);
    }

    function f() {
      var r;
      return r = l(), r === L && (r = m()), r;
    }

    function l() {
      var r, t, e, o, n;
      return r = At, t = h(), t !== L ? (e = p(), e === L && (e = null), e !== L ? (o = g(), o !== L ? (n = x(), n === L && (n = null), n !== L ? (gt = r, t = D(e, o, n), r = t) : (At = r, r = L)) : (At = r, r = L)) : (At = r, r = L)) : (At = r, r = L), r;
    }

    function h() {
      var t, e, o, n, u;

      for (t = At, e = [], o = T(); o !== L;) {
        e.push(o), o = T();
      }

      return e !== L ? (r.substr(At, 2) === z ? (o = z, At += 2) : (o = L, 0 === It && c(J)), o !== L ? (r.substr(At, 2) === V ? (n = V, At += 2) : (n = L, 0 === It && c(Z)), n === L && (r.substr(At, 2) === $ ? (n = $, At += 2) : (n = L, 0 === It && c(q))), n === L && (n = null), n !== L ? (u = R(), u !== L ? (e = [e, o, n, u], t = e) : (At = t, t = L)) : (At = t, t = L)) : (At = t, t = L)) : (At = t, t = L), t;
    }

    function p() {
      var r, t, e;
      return r = At, t = A(), t === L && (t = null), t !== L ? (e = d(), e !== L ? (gt = r, t = Q(t, e), r = t) : (At = r, r = L)) : (At = r, r = L), r;
    }

    function d() {
      var r, t, e;

      for (r = At, t = [], e = v(); e !== L;) {
        t.push(e), e = v();
      }

      return t !== L && (gt = r, t = X(t)), r = t;
    }

    function v() {
      var t, e, o, n, u, i, a;

      for (t = At, e = [], o = T(); o !== L;) {
        e.push(o), o = T();
      }

      if (e !== L) {
        if (36 === r.charCodeAt(At) ? (o = rr, At++) : (o = L, 0 === It && c(tr)), o !== L) {
          if (n = [], er.test(r.charAt(At)) ? (u = r.charAt(At), At++) : (u = L, 0 === It && c(or)), u !== L) for (; u !== L;) {
            n.push(u), er.test(r.charAt(At)) ? (u = r.charAt(At), At++) : (u = L, 0 === It && c(or));
          } else n = L;
          if (n !== L) {
            if (58 === r.charCodeAt(At) ? (u = nr, At++) : (u = L, 0 === It && c(ur)), u !== L) {
              for (i = [], a = G(); a !== L;) {
                i.push(a), a = G();
              }

              i !== L ? (a = R(), a !== L ? (gt = t, e = ir(n, i), t = e) : (At = t, t = L)) : (At = t, t = L);
            } else At = t, t = L;
          } else At = t, t = L;
        } else At = t, t = L;
      } else At = t, t = L;
      return t;
    }

    function m() {
      var r, t, e, o;
      return r = At, t = A(), t === L && (t = null), t !== L ? (e = g(), e === L && (e = null), e !== L ? (o = x(), o !== L ? (gt = r, t = ar(t, e, o), r = t) : (At = r, r = L)) : (At = r, r = L)) : (At = r, r = L), r;
    }

    function A() {
      var t, e, o, n, u, i, a, s;

      for (t = At, e = [], o = T(); o !== L;) {
        e.push(o), o = T();
      }

      if (e !== L) {
        if (o = At, r.substr(At, 2) === cr ? (n = cr, At += 2) : (n = L, 0 === It && c(sr)), n !== L) {
          for (u = [], i = G(); i !== L;) {
            u.push(i), i = G();
          }

          u !== L ? (i = R(), i !== L ? (gt = o, n = fr(u), o = n) : (At = o, o = L)) : (At = o, o = L);
        } else At = o, o = L;

        if (o === L && (o = null), o !== L) {
          for (n = [], u = T(); u !== L;) {
            n.push(u), u = T();
          }

          if (n !== L) {
            if (u = At, r.substr(At, 2) === lr ? (i = lr, At += 2) : (i = L, 0 === It && c(hr)), i !== L) {
              for (a = [], s = G(); s !== L;) {
                a.push(s), s = G();
              }

              a !== L ? (s = R(), s !== L ? (gt = u, i = pr(o, a), u = i) : (At = u, u = L)) : (At = u, u = L);
            } else At = u, u = L;

            u === L && (u = null), u !== L ? (gt = t, e = dr(o, u), t = e) : (At = t, t = L);
          } else At = t, t = L;
        } else At = t, t = L;
      } else At = t, t = L;

      return t;
    }

    function g() {
      var r, t, e, o, n, u, i;

      for (r = At, t = [], e = T(); e !== L;) {
        t.push(e), e = T();
      }

      if (t !== L) {
        if (e = k(), e === L && (e = y()) === L && (e = At, o = vr, o !== L && (gt = e, o = mr()), e = o), e !== L) {
          if ((o = C()) !== L) {
            for (n = [], u = T(); u !== L;) {
              n.push(u), u = T();
            }

            n !== L ? (u = M(), u !== L ? (i = R(), i !== L ? (gt = r, t = Ar(e, o, u), r = t) : (At = r, r = L)) : (At = r, r = L)) : (At = r, r = L);
          } else At = r, r = L;
        } else At = r, r = L;
      } else At = r, r = L;
      return r;
    }

    function k() {
      var t, e, o, n;

      if (t = At, r.substr(At, 2) === gr ? (e = gr, At += 2) : (e = L, 0 === It && c(kr)), e !== L) {
        for (o = [], n = N(); n !== L;) {
          o.push(n), n = N();
        }

        o !== L ? (n = R(), n !== L ? (gt = t, e = yr(o), t = e) : (At = t, t = L)) : (At = t, t = L);
      } else At = t, t = L;

      return t;
    }

    function y() {
      var r, t, e;
      if (r = At, t = [], (e = K()) !== L) for (; e !== L;) {
        t.push(e), e = K();
      } else t = L;
      return t !== L && (gt = r, t = Kr(t)), r = t;
    }

    function K() {
      var t, e, o, n, u;
      if (t = At, 80 === r.charCodeAt(At) ? (e = Ir, At++) : (e = L, 0 === It && c(Cr)), e !== L) {
        if (Fr.test(r.charAt(At)) ? (o = r.charAt(At), At++) : (o = L, 0 === It && c(xr)), o !== L) {
          if (n = [], (u = I()) !== L) for (; u !== L;) {
            n.push(u), u = I();
          } else n = L;
          n !== L ? (u = R(), u !== L ? (gt = t, e = Er(n), t = e) : (At = t, t = L)) : (At = t, t = L);
        } else At = t, t = L;
      } else At = t, t = L;
      return t;
    }

    function I() {
      var t, e, o;
      return t = At, e = M(), e !== L ? (o = H(), o !== L ? (gt = t, e = Ur(e, o), t = e) : (At = t, t = L)) : (At = t, t = L), t === L && (t = At, r.substr(At, 3) === br ? (e = br, At += 3) : (e = L, 0 === It && c(wr)), e !== L && (gt = t, e = Mr()), t = e), t;
    }

    function C() {
      var r, t, e;

      for (r = At, t = [], e = F(); e !== L;) {
        t.push(e), e = F();
      }

      return t !== L && (gt = r, t = Tr(t)), r = t;
    }

    function F() {
      var t, e, o, n, u;
      if (t = At, 80 === r.charCodeAt(At) ? (e = Ir, At++) : (e = L, 0 === It && c(Cr)), e !== L) {
        if ((o = M()) !== L) {
          if (n = [], (u = N()) !== L) for (; u !== L;) {
            n.push(u), u = N();
          } else n = L;
          n !== L ? (u = R(), u !== L ? (gt = t, e = Or(o, n), t = e) : (At = t, t = L)) : (At = t, t = L);
        } else At = t, t = L;
      } else At = t, t = L;
      return t;
    }

    function x() {
      var r, t, e, o, n;

      if (r = At, (t = E()) !== L) {
        for (e = [], o = U(); o !== L;) {
          e.push(o), o = U();
        }

        if (e !== L) {
          for (o = [], n = T(); n !== L;) {
            o.push(n), n = T();
          }

          o !== L ? (gt = r, t = Sr(t, e), r = t) : (At = r, r = L);
        } else At = r, r = L;
      } else At = r, r = L;

      return r;
    }

    function E() {
      var r, t, e;

      for (r = At, t = [], e = T(); e !== L;) {
        t.push(e), e = T();
      }

      return t !== L && (gt = r, t = Hr(t)), r = t;
    }

    function U() {
      var r, t, e, o, n;
      if (r = At, t = b(), t === L && (t = w()), t !== L) {
        if (e = O(), e === L && (e = null), e !== L) {
          for (o = [], n = T(); n !== L;) {
            o.push(n), n = T();
          }

          o !== L ? (gt = r, t = Nr(t, e, o), r = t) : (At = r, r = L);
        } else At = r, r = L;
      } else At = r, r = L;
      return r;
    }

    function b() {
      var r, t, e, o, n, u;
      return r = At, t = M(), t !== L ? (e = S(), e !== L ? (o = S(), o !== L ? (n = H(), n !== L ? (u = R(), u !== L ? (gt = r, t = Rr(e, o, n), r = t) : (At = r, r = L)) : (At = r, r = L)) : (At = r, r = L)) : (At = r, r = L)) : (At = r, r = L), r;
    }

    function w() {
      var t, e, o, n;

      if (t = At, 37 === r.charCodeAt(At) ? (e = Gr, At++) : (e = L, 0 === It && c(Yr)), e !== L) {
        if (o = [], Br.test(r.charAt(At)) ? (n = r.charAt(At), At++) : (n = L, 0 === It && c(Pr)), n !== L) for (; n !== L;) {
          o.push(n), Br.test(r.charAt(At)) ? (n = r.charAt(At), At++) : (n = L, 0 === It && c(Pr));
        } else o = L;
        o !== L ? (n = R(), n !== L ? (gt = t, e = _r(o), t = e) : (At = t, t = L)) : (At = t, t = L);
      } else At = t, t = L;

      return t;
    }

    function M() {
      var t, e;
      return t = At, 43 === r.charCodeAt(At) ? (e = Lr, At++) : (e = L, 0 === It && c(jr)), e !== L && (gt = t, e = Wr()), t = e, t === L && (t = At, 45 === r.charCodeAt(At) ? (e = Dr, At++) : (e = L, 0 === It && c(zr)), e !== L && (gt = t, e = Jr()), t = e), t;
    }

    function T() {
      var t, e, o, n;

      if (t = At, 39 === r.charCodeAt(At) ? (e = Vr, At++) : (e = L, 0 === It && c(Zr)), e !== L) {
        for (o = [], n = G(); n !== L;) {
          o.push(n), n = G();
        }

        o !== L ? (n = R(), n !== L ? (gt = t, e = $r(o), t = e) : (At = t, t = L)) : (At = t, t = L);
      } else At = t, t = L;

      return t;
    }

    function O() {
      var t, e, o, n;

      if (t = At, 84 === r.charCodeAt(At) ? (e = qr, At++) : (e = L, 0 === It && c(Qr)), e !== L) {
        for (o = [], Xr.test(r.charAt(At)) ? (n = r.charAt(At), At++) : (n = L, 0 === It && c(rt)); n !== L;) {
          o.push(n), Xr.test(r.charAt(At)) ? (n = r.charAt(At), At++) : (n = L, 0 === It && c(rt));
        }

        o !== L ? (n = R(), n !== L ? (gt = t, e = tt(o), t = e) : (At = t, t = L)) : (At = t, t = L);
      } else At = t, t = L;

      return t;
    }

    function S() {
      var t, e, o;
      return t = At, Xr.test(r.charAt(At)) ? (e = r.charAt(At), At++) : (e = L, 0 === It && c(rt)), e !== L ? (Xr.test(r.charAt(At)) ? (o = r.charAt(At), At++) : (o = L, 0 === It && c(rt)), o !== L ? (gt = t, e = et(e, o), t = e) : (At = t, t = L)) : (At = t, t = L), t;
    }

    function H() {
      var t, e, o;
      return t = At, ot.test(r.charAt(At)) ? (e = r.charAt(At), At++) : (e = L, 0 === It && c(nt)), e !== L ? (ot.test(r.charAt(At)) ? (o = r.charAt(At), At++) : (o = L, 0 === It && c(nt)), o !== L ? (gt = t, e = ut(e, o), t = e) : (At = t, t = L)) : (At = t, t = L), t;
    }

    function N() {
      var r, t, e;
      return r = At, t = S(), t !== L ? (e = H(), e !== L ? (gt = r, t = it(t, e), r = t) : (At = r, r = L)) : (At = r, r = L), r;
    }

    function R() {
      var t, e, o;

      if (t = At, 13 === r.charCodeAt(At) ? (e = at, At++) : (e = L, 0 === It && c(ct)), e === L && (e = null), e !== L ? (10 === r.charCodeAt(At) ? (o = st, At++) : (o = L, 0 === It && c(ft)), o !== L ? (e = [e, o], t = e) : (At = t, t = L)) : (At = t, t = L), t === L) {
        for (t = At, e = [], 32 === r.charCodeAt(At) ? (o = lt, At++) : (o = L, 0 === It && c(ht)); o !== L;) {
          e.push(o), 32 === r.charCodeAt(At) ? (o = lt, At++) : (o = L, 0 === It && c(ht));
        }

        e !== L ? (44 === r.charCodeAt(At) ? (o = pt, At++) : (o = L, 0 === It && c(dt)), o !== L ? (e = [e, o], t = e) : (At = t, t = L)) : (At = t, t = L);
      }

      return t;
    }

    function G() {
      var t;
      return vt.test(r.charAt(At)) ? (t = r.charAt(At), At++) : (t = L, 0 === It && c(mt)), t;
    }

    function Y(r) {
      var t,
          e = r % 60;
      return t = (r - e) / 60, {
        m: t,
        s: e
      };
    }

    function B() {
      return [[{
        color: 1,
        kind: "KY"
      }, {}, {
        color: 1,
        kind: "FU"
      }, {}, {}, {}, {
        color: 0,
        kind: "FU"
      }, {}, {
        color: 0,
        kind: "KY"
      }], [{
        color: 1,
        kind: "KE"
      }, {
        color: 1,
        kind: "KA"
      }, {
        color: 1,
        kind: "FU"
      }, {}, {}, {}, {
        color: 0,
        kind: "FU"
      }, {
        color: 0,
        kind: "HI"
      }, {
        color: 0,
        kind: "KE"
      }], [{
        color: 1,
        kind: "GI"
      }, {}, {
        color: 1,
        kind: "FU"
      }, {}, {}, {}, {
        color: 0,
        kind: "FU"
      }, {}, {
        color: 0,
        kind: "GI"
      }], [{
        color: 1,
        kind: "KI"
      }, {}, {
        color: 1,
        kind: "FU"
      }, {}, {}, {}, {
        color: 0,
        kind: "FU"
      }, {}, {
        color: 0,
        kind: "KI"
      }], [{
        color: 1,
        kind: "OU"
      }, {}, {
        color: 1,
        kind: "FU"
      }, {}, {}, {}, {
        color: 0,
        kind: "FU"
      }, {}, {
        color: 0,
        kind: "OU"
      }], [{
        color: 1,
        kind: "KI"
      }, {}, {
        color: 1,
        kind: "FU"
      }, {}, {}, {}, {
        color: 0,
        kind: "FU"
      }, {}, {
        color: 0,
        kind: "KI"
      }], [{
        color: 1,
        kind: "GI"
      }, {}, {
        color: 1,
        kind: "FU"
      }, {}, {}, {}, {
        color: 0,
        kind: "FU"
      }, {}, {
        color: 0,
        kind: "GI"
      }], [{
        color: 1,
        kind: "KE"
      }, {
        color: 1,
        kind: "HI"
      }, {
        color: 1,
        kind: "FU"
      }, {}, {}, {}, {
        color: 0,
        kind: "FU"
      }, {
        color: 0,
        kind: "KA"
      }, {
        color: 0,
        kind: "KE"
      }], [{
        color: 1,
        kind: "KY"
      }, {}, {
        color: 1,
        kind: "FU"
      }, {}, {}, {}, {
        color: 0,
        kind: "FU"
      }, {}, {
        color: 0,
        kind: "KY"
      }]];
    }

    function P(r) {
      return {
        EVENT: "棋戦",
        SITE: "場所",
        START_TIME: "開始日時",
        END_TIME: "終了日時",
        TIME_LIMIT: "持ち時間"
      }[r] || r;
    }

    t = void 0 !== t ? t : {};

    var _,
        L = {},
        j = {
      kifu: f
    },
        W = f,
        D = function D(r, t, e) {
      var o = {
        header: r.header,
        initial: t,
        moves: e
      };
      return r && r.players && (r.players[0] && (o.header["先手"] = r.players[0]), r.players[1] && (o.header["後手"] = r.players[1])), o;
    },
        z = "V2",
        J = e("V2", !1),
        V = ".1",
        Z = e(".1", !1),
        $ = ".2",
        q = e(".2", !1),
        Q = function Q(r, t) {
      return {
        players: r,
        header: t
      };
    },
        X = function X(r) {
      for (var t = {}, e = 0; e < r.length; e++) {
        t[P(r[e].k)] = r[e].v;
      }

      return t;
    },
        rr = "$",
        tr = e("$", !1),
        er = /^[^:]/,
        or = n([":"], !0, !1),
        nr = ":",
        ur = e(":", !1),
        ir = function ir(r, t) {
      return {
        k: r.join(""),
        v: t.join("")
      };
    },
        ar = function ar(r, t, e) {
      var o = {
        header: {},
        initial: t,
        moves: e
      };
      return r && (r[0] && (o.header["先手"] = r[0]), r[1] && (o.header["後手"] = r[1])), o;
    },
        cr = "N+",
        sr = e("N+", !1),
        fr = function fr(r) {
      return r;
    },
        lr = "N-",
        hr = e("N-", !1),
        pr = function pr(r, t) {
      return t;
    },
        dr = function dr(r, t) {
      return [r ? r.join("") : null, t ? t.join("") : null];
    },
        vr = "",
        mr = function mr() {
      return "NO";
    },
        Ar = function Ar(r, t, e) {
      return "NO" == r ? r = t : r.data.hands = t.data.hands, r.data.color = e, r;
    },
        gr = "PI",
        kr = e("PI", !1),
        yr = function yr(r) {
      for (var t = {
        preset: "OTHER",
        data: {
          board: B()
        }
      }, e = 0; e < r.length; e++) {
        t.data.board[r[e].xy.x - 1][r[e].xy.y - 1] = {};
      }

      return t;
    },
        Kr = function Kr(r) {
      for (var t = [], e = 0; e < 9; e++) {
        for (var o = [], n = 0; n < 9; n++) {
          o.push(r[n][8 - e]);
        }

        t.push(o);
      }

      return {
        preset: "OTHER",
        data: {
          board: t
        }
      };
    },
        Ir = "P",
        Cr = e("P", !1),
        Fr = /^[1-9]/,
        xr = n([["1", "9"]], !1, !1),
        Er = function Er(r) {
      return r;
    },
        Ur = function Ur(r, t) {
      return {
        color: r,
        kind: t
      };
    },
        br = " * ",
        wr = e(" * ", !1),
        Mr = function Mr() {
      return {};
    },
        Tr = function Tr(r) {
      for (var t = [], e = [{
        FU: 0,
        KY: 0,
        KE: 0,
        GI: 0,
        KI: 0,
        KA: 0,
        HI: 0
      }, {
        FU: 0,
        KY: 0,
        KE: 0,
        GI: 0,
        KI: 0,
        KA: 0,
        HI: 0
      }], o = {
        FU: 18,
        KY: 4,
        KE: 4,
        GI: 4,
        KI: 4,
        KA: 2,
        HI: 2
      }, n = 0; n < 9; n++) {
        for (var u = [], i = 0; i < 9; i++) {
          u.push({});
        }

        t.push(u);
      }

      r: for (var n = 0; n < r.length; n++) {
        for (var i = 0; i < r[n].pieces.length; i++) {
          var a = r[n].pieces[i];

          if (0 == a.xy.x) {
            if ("AL" == a.piece) {
              e[r[n].teban] = o;
              break r;
            }

            var c = e[r[n].teban];
            c[a.piece]++;
          } else t[a.xy.x - 1][a.xy.y - 1] = {
            color: r[n].teban,
            kind: a.piece
          };

          "OU" != a.piece && o[a.piece]--;
        }
      }

      return {
        preset: "OTHER",
        data: {
          board: t,
          hands: e
        }
      };
    },
        Or = function Or(r, t) {
      return {
        teban: r,
        pieces: t
      };
    },
        Sr = function Sr(r, t) {
      return t.unshift(r), t;
    },
        Hr = function Hr(r) {
      return r.length > 0 ? {
        comments: r
      } : {};
    },
        Nr = function Nr(r, t, e) {
      var o = {};
      return e.length > 0 && (o.comments = e), t && (o.time = t), r.special ? o.special = r.special : o.move = r, o;
    },
        Rr = function Rr(r, t, e) {
      var o = {
        to: t,
        piece: e
      };
      return 0 != r.x && (o.from = r), o;
    },
        Gr = "%",
        Yr = e("%", !1),
        Br = /^[\-+_A-Z]/,
        Pr = n(["-", "+", "_", ["A", "Z"]], !1, !1),
        _r = function _r(r) {
      return {
        special: r.join("")
      };
    },
        Lr = "+",
        jr = e("+", !1),
        Wr = function Wr() {
      return 0;
    },
        Dr = "-",
        zr = e("-", !1),
        Jr = function Jr() {
      return 1;
    },
        Vr = "'",
        Zr = e("'", !1),
        $r = function $r(r) {
      return r.join("");
    },
        qr = "T",
        Qr = e("T", !1),
        Xr = /^[0-9]/,
        rt = n([["0", "9"]], !1, !1),
        tt = function tt(r) {
      return {
        now: Y(parseInt(r.join("")))
      };
    },
        et = function et(r, t) {
      return {
        x: parseInt(r),
        y: parseInt(t)
      };
    },
        ot = /^[A-Z]/,
        nt = n([["A", "Z"]], !1, !1),
        ut = function ut(r, t) {
      return r + t;
    },
        it = function it(r, t) {
      return {
        xy: r,
        piece: t
      };
    },
        at = "\r",
        ct = e("\r", !1),
        st = "\n",
        ft = e("\n", !1),
        lt = " ",
        ht = e(" ", !1),
        pt = ",",
        dt = e(",", !1),
        vt = /^[^\r\n]/,
        mt = n(["\r", "\n"], !0, !1),
        At = 0,
        gt = 0,
        kt = [{
      line: 1,
      column: 1
    }],
        yt = 0,
        Kt = [],
        It = 0;

    if ("startRule" in t) {
      if (!(t.startRule in j)) throw new Error("Can't start parsing from rule \"" + t.startRule + '".');
      W = j[t.startRule];
    }

    if ((_ = W()) !== L && At === r.length) return _;
    throw _ !== L && At < r.length && c(function () {
      return {
        type: "end"
      };
    }()), s(Kt, yt < r.length ? r.charAt(yt) : null, yt < r.length ? a(yt, yt + 1) : a(yt, yt));
  }

  !function (r, t) {
    function e() {
      this.constructor = r;
    }

    e.prototype = t.prototype, r.prototype = new e();
  }(o, Error), o.buildMessage = function (r, t) {
    function e(r) {
      return r.charCodeAt(0).toString(16).toUpperCase();
    }

    function o(r) {
      return r.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function (r) {
        return "\\x0" + e(r);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (r) {
        return "\\x" + e(r);
      });
    }

    function n(r) {
      return r.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function (r) {
        return "\\x0" + e(r);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (r) {
        return "\\x" + e(r);
      });
    }

    function u(r) {
      return i[r.type](r);
    }

    var i = {
      literal: function literal(r) {
        return '"' + o(r.text) + '"';
      },
      class: function _class(r) {
        var t,
            e = "";

        for (t = 0; t < r.parts.length; t++) {
          e += r.parts[t] instanceof Array ? n(r.parts[t][0]) + "-" + n(r.parts[t][1]) : n(r.parts[t]);
        }

        return "[" + (r.inverted ? "^" : "") + e + "]";
      },
      any: function any(r) {
        return "any character";
      },
      end: function end(r) {
        return "end of input";
      },
      other: function other(r) {
        return r.description;
      }
    };
    return "Expected " + function (r) {
      var t,
          e,
          o = new Array(r.length);

      for (t = 0; t < r.length; t++) {
        o[t] = u(r[t]);
      }

      if (o.sort(), o.length > 0) {
        for (t = 1, e = 1; t < o.length; t++) {
          o[t - 1] !== o[t] && (o[e] = o[t], e++);
        }

        o.length = e;
      }

      switch (o.length) {
        case 1:
          return o[0];

        case 2:
          return o[0] + " or " + o[1];

        default:
          return o.slice(0, -1).join(", ") + ", or " + o[o.length - 1];
      }
    }(r) + " but " + function (r) {
      return r ? '"' + o(r) + '"' : "end of input";
    }(t) + " found.";
  }, r.exports = {
    SyntaxError: o,
    parse: n
  };
}, function (r, t, e) {
  "use strict";

  function o(r, t, e, n) {
    this.message = r, this.expected = t, this.found = e, this.location = n, this.name = "SyntaxError", "function" == typeof Error.captureStackTrace && Error.captureStackTrace(this, o);
  }

  function n(r, t) {
    function e(r, t) {
      return {
        type: "literal",
        text: r,
        ignoreCase: t
      };
    }

    function n(r, t, e) {
      return {
        type: "class",
        parts: r,
        inverted: t,
        ignoreCase: e
      };
    }

    function u(r) {
      return {
        type: "other",
        description: r
      };
    }

    function i(t) {
      var e,
          o = pe[t];
      if (o) return o;

      for (e = t - 1; !pe[e];) {
        e--;
      }

      for (o = pe[e], o = {
        line: o.line,
        column: o.column
      }; e < t;) {
        10 === r.charCodeAt(e) ? (o.line++, o.column = 1) : o.column++, e++;
      }

      return pe[t] = o, o;
    }

    function a(r, t) {
      var e = i(r),
          o = i(t);
      return {
        start: {
          offset: r,
          line: e.line,
          column: e.column
        },
        end: {
          offset: t,
          line: o.line,
          column: o.column
        }
      };
    }

    function c(r) {
      le < de || (le > de && (de = le, ve = []), ve.push(r));
    }

    function s(r, t, e) {
      return new o(o.buildMessage(r, t), r, t, e);
    }

    function f() {
      var r, t, e, o, n, u, i;

      for (r = le, t = [], e = l(); e !== z;) {
        t.push(e), e = l();
      }

      if (t !== z) {
        if (e = h(), e === z && (e = null), e !== z) {
          for (o = [], n = l(); n !== z;) {
            o.push(n), n = l();
          }

          if (o !== z) {
            if ((n = m()) !== z) {
              for (u = [], i = M(); i !== z;) {
                u.push(i), i = M();
              }

              u !== z ? (he = r, t = Z(t, e, o, n, u), r = t) : (le = r, r = z);
            } else le = r, r = z;
          } else le = r, r = z;
        } else le = r, r = z;
      } else le = r, r = z;
      return r;
    }

    function l() {
      var t, e, o, n, u, i;
      if (t = le, e = [], $.test(r.charAt(le)) ? (o = r.charAt(le), le++) : (o = z, 0 === me && c(q)), o !== z) for (; o !== z;) {
        e.push(o), $.test(r.charAt(le)) ? (o = r.charAt(le), le++) : (o = z, 0 === me && c(q));
      } else e = z;
      if (e !== z) {
        if (65306 === r.charCodeAt(le) ? (o = Q, le++) : (o = z, 0 === me && c(X)), o !== z) {
          for (n = [], u = R(); u !== z;) {
            n.push(u), u = R();
          }

          if (n !== z) {
            if (u = [], (i = O()) !== z) for (; i !== z;) {
              u.push(i), i = O();
            } else u = z;
            u !== z ? (he = t, e = rr(e, n), t = e) : (le = t, t = z);
          } else le = t, t = z;
        } else le = t, t = z;
      } else le = t, t = z;
      return t === z && (t = le, tr.test(r.charAt(le)) ? (e = r.charAt(le), le++) : (e = z, 0 === me && c(er)), e !== z ? (r.substr(le, 2) === or ? (o = or, le += 2) : (o = z, 0 === me && c(nr)), o !== z ? (n = O(), n !== z ? (he = t, e = ur(e), t = e) : (le = t, t = z)) : (le = t, t = z)) : (le = t, t = z)), t;
    }

    function h() {
      var t, e, o, n, u, i, a, s;

      if (t = le, e = le, 32 === r.charCodeAt(le) ? (o = ir, le++) : (o = z, 0 === me && c(ar)), o !== z) {
        for (n = [], u = R(); u !== z;) {
          n.push(u), u = R();
        }

        n !== z ? (u = O(), u !== z ? (o = [o, n, u], e = o) : (le = e, e = z)) : (le = e, e = z);
      } else le = e, e = z;

      if (e === z && (e = null), e !== z) {
        if (o = le, 43 === r.charCodeAt(le) ? (n = cr, le++) : (n = z, 0 === me && c(sr)), n !== z) {
          for (u = [], i = R(); i !== z;) {
            u.push(i), i = R();
          }

          u !== z ? (i = O(), i !== z ? (n = [n, u, i], o = n) : (le = o, o = z)) : (le = o, o = z);
        } else le = o, o = z;

        if (o === z && (o = null), o !== z) {
          if (n = [], (u = p()) !== z) for (; u !== z;) {
            n.push(u), u = p();
          } else n = z;

          if (n !== z) {
            if (u = le, 43 === r.charCodeAt(le) ? (i = cr, le++) : (i = z, 0 === me && c(sr)), i !== z) {
              for (a = [], s = R(); s !== z;) {
                a.push(s), s = R();
              }

              a !== z ? (s = O(), s !== z ? (i = [i, a, s], u = i) : (le = u, u = z)) : (le = u, u = z);
            } else le = u, u = z;

            u === z && (u = null), u !== z ? (he = t, e = fr(n), t = e) : (le = t, t = z);
          } else le = t, t = z;
        } else le = t, t = z;
      } else le = t, t = z;

      return t;
    }

    function p() {
      var t, e, o, n, u, i;

      if (t = le, 124 === r.charCodeAt(le) ? (e = lr, le++) : (e = z, 0 === me && c(hr)), e !== z) {
        if (o = [], (n = d()) !== z) for (; n !== z;) {
          o.push(n), n = d();
        } else o = z;
        if (o !== z) {
          if (124 === r.charCodeAt(le) ? (n = lr, le++) : (n = z, 0 === me && c(hr)), n !== z) {
            if (u = [], (i = R()) !== z) for (; i !== z;) {
              u.push(i), i = R();
            } else u = z;
            u !== z ? (i = O(), i !== z ? (he = t, e = pr(o), t = e) : (le = t, t = z)) : (le = t, t = z);
          } else le = t, t = z;
        } else le = t, t = z;
      } else le = t, t = z;

      return t;
    }

    function d() {
      var t, e, o;
      return t = le, e = v(), e !== z ? (o = C(), o !== z ? (he = t, e = dr(e, o), t = e) : (le = t, t = z)) : (le = t, t = z), t === z && (t = le, r.substr(le, 2) === vr ? (e = vr, le += 2) : (e = z, 0 === me && c(mr)), e !== z && (he = t, e = Ar()), t = e), t;
    }

    function v() {
      var t, e;
      return t = le, 32 === r.charCodeAt(le) ? (e = ir, le++) : (e = z, 0 === me && c(ar)), e === z && (43 === r.charCodeAt(le) ? (e = cr, le++) : (e = z, 0 === me && c(sr)), e === z && (94 === r.charCodeAt(le) ? (e = gr, le++) : (e = z, 0 === me && c(kr)))), e !== z && (he = t, e = yr()), t = e, t === z && (t = le, 118 === r.charCodeAt(le) ? (e = Kr, le++) : (e = z, 0 === me && c(Ir)), e === z && (86 === r.charCodeAt(le) ? (e = Cr, le++) : (e = z, 0 === me && c(Fr))), e !== z && (he = t, e = xr()), t = e), t;
    }

    function m() {
      var r, t, e, o;

      if (r = le, (t = A()) !== z) {
        for (e = [], o = g(); o !== z;) {
          e.push(o), o = g();
        }

        e !== z ? (o = w(), o === z && (o = null), o !== z ? (he = r, t = Er(t, e, o), r = t) : (le = r, r = z)) : (le = r, r = z);
      } else le = r, r = z;

      return r;
    }

    function A() {
      var r, t, e;

      for (r = le, t = [], e = b(); e !== z;) {
        t.push(e), e = b();
      }

      return t !== z ? (e = k(), e === z && (e = null), e !== z ? (he = r, t = Ur(t), r = t) : (le = r, r = z)) : (le = r, r = z), r;
    }

    function g() {
      var t, e, o, n, u, i;

      if (t = le, (e = y()) !== z) {
        for (o = [], n = b(); n !== z;) {
          o.push(n), n = b();
        }

        if (o !== z) {
          if (n = k(), n === z && (n = null), n !== z) {
            for (u = [], i = O(), i === z && (32 === r.charCodeAt(le) ? (i = ir, le++) : (i = z, 0 === me && c(ar))); i !== z;) {
              u.push(i), (i = O()) === z && (32 === r.charCodeAt(le) ? (i = ir, le++) : (i = z, 0 === me && c(ar)));
            }

            u !== z ? (he = t, e = br(e, o), t = e) : (le = t, t = z);
          } else le = t, t = z;
        } else le = t, t = z;
      } else le = t, t = z;

      return t;
    }

    function k() {
      var t, e, o, n;

      if (t = le, 38 === r.charCodeAt(le) ? (e = wr, le++) : (e = z, 0 === me && c(Mr)), e !== z) {
        for (o = [], n = R(); n !== z;) {
          o.push(n), n = R();
        }

        o !== z ? (n = O(), n !== z ? (e = [e, o, n], t = e) : (le = t, t = z)) : (le = t, t = z);
      } else le = t, t = z;

      return t;
    }

    function y() {
      var t, e, o, n, u;
      if (t = le, Tr.test(r.charAt(le)) ? (e = r.charAt(le), le++) : (e = z, 0 === me && c(Or)), e !== z) {
        if ((o = K()) !== z) {
          for (n = [], u = O(), u === z && (32 === r.charCodeAt(le) ? (u = ir, le++) : (u = z, 0 === me && c(ar))); u !== z;) {
            n.push(u), (u = O()) === z && (32 === r.charCodeAt(le) ? (u = ir, le++) : (u = z, 0 === me && c(ar)));
          }

          n !== z ? (he = t, e = Sr(o), t = e) : (le = t, t = z);
        } else le = t, t = z;
      } else le = t, t = z;
      return t;
    }

    function K() {
      var t, e, o, n, u, i, a;
      return t = le, e = I(), e !== z ? (o = C(), o !== z ? (n = F(), n === z && (n = null), n !== z ? (u = x(), u === z && (u = null), u !== z ? (25104 === r.charCodeAt(le) ? (i = Hr, le++) : (i = z, 0 === me && c(Nr)), i === z && (r.substr(le, 2) === Rr ? (i = Rr, le += 2) : (i = z, 0 === me && c(Gr))), i === z && (i = null), i !== z ? (25171 === r.charCodeAt(le) ? (a = Yr, le++) : (a = z, 0 === me && c(Br)), a === z && (a = null), a !== z ? (he = t, e = Pr(e, o, n, u, i, a), t = e) : (le = t, t = z)) : (le = t, t = z)) : (le = t, t = z)) : (le = t, t = z)) : (le = t, t = z)) : (le = t, t = z), t;
    }

    function I() {
      var t, e, o;
      return t = le, e = E(), e !== z ? (o = U(), o !== z ? (he = t, e = _r(e, o), t = e) : (le = t, t = z)) : (le = t, t = z), t === z && (t = le, 21516 === r.charCodeAt(le) ? (e = Lr, le++) : (e = z, 0 === me && c(jr)), e !== z ? (12288 === r.charCodeAt(le) ? (o = Wr, le++) : (o = z, 0 === me && c(Dr)), o === z && (o = null), o !== z ? (he = t, e = zr(), t = e) : (le = t, t = z)) : (le = t, t = z)), t;
    }

    function C() {
      var t, e, o;
      return t = le, 25104 === r.charCodeAt(le) ? (e = Hr, le++) : (e = z, 0 === me && c(Nr)), e === z && (e = null), e !== z ? (Jr.test(r.charAt(le)) ? (o = r.charAt(le), le++) : (o = z, 0 === me && c(Vr)), o !== z ? (he = t, e = Zr(e, o), t = e) : (le = t, t = z)) : (le = t, t = z), t;
    }

    function F() {
      var t;
      return $r.test(r.charAt(le)) ? (t = r.charAt(le), le++) : (t = z, 0 === me && c(qr)), t;
    }

    function x() {
      var t;
      return Qr.test(r.charAt(le)) ? (t = r.charAt(le), le++) : (t = z, 0 === me && c(Xr)), t;
    }

    function E() {
      var t, e;
      return t = le, rt.test(r.charAt(le)) ? (e = r.charAt(le), le++) : (e = z, 0 === me && c(tt)), e !== z && (he = t, e = et(e)), t = e;
    }

    function U() {
      var t, e;
      return t = le, ot.test(r.charAt(le)) ? (e = r.charAt(le), le++) : (e = z, 0 === me && c(nt)), e !== z && (he = t, e = ut(e)), t = e;
    }

    function b() {
      var t, e, o, n;

      if (t = le, 42 === r.charCodeAt(le) ? (e = it, le++) : (e = z, 0 === me && c(at)), e !== z) {
        for (o = [], n = R(); n !== z;) {
          o.push(n), n = R();
        }

        o !== z ? (n = O(), n !== z ? (he = t, e = ct(o), t = e) : (le = t, t = z)) : (le = t, t = z);
      } else le = t, t = z;

      return t;
    }

    function w() {
      var t, e, o, n, u, i, a, s, f, l, h, p;

      if (t = le, r.substr(le, 2) === st ? (e = st, le += 2) : (e = z, 0 === me && c(ft)), e !== z) {
        if (o = [], lt.test(r.charAt(le)) ? (n = r.charAt(le), le++) : (n = z, 0 === me && c(ht)), n !== z) for (; n !== z;) {
          o.push(n), lt.test(r.charAt(le)) ? (n = r.charAt(le), le++) : (n = z, 0 === me && c(ht));
        } else o = z;
        o !== z ? (25163 === r.charCodeAt(le) ? (n = pt, le++) : (n = z, 0 === me && c(dt)), n !== z ? (u = le, 12391 === r.charCodeAt(le) ? (i = vt, le++) : (i = z, 0 === me && c(mt)), i !== z ? (a = T(), a !== z ? (r.substr(le, 2) === At ? (s = At, le += 2) : (s = z, 0 === me && c(gt)), s !== z ? (f = le, r.substr(le, 2) === kt ? (l = kt, le += 2) : (l = z, 0 === me && c(yt)), l !== z && (he = f, l = Kt(a)), f = l, f === z && (f = le, r.substr(le, 2) === It ? (l = It, le += 2) : (l = z, 0 === me && c(Ct)), l !== z ? (h = le, r.substr(le, 2) === kt ? (p = kt, le += 2) : (p = z, 0 === me && c(yt)), p !== z && (he = h, p = Ft(a)), h = p, h === z && (h = le, r.substr(le, 2) === xt ? (p = xt, le += 2) : (p = z, 0 === me && c(Et)), p !== z && (he = h, p = Ut(a)), h = p), h !== z ? (he = f, l = bt(a, h), f = l) : (le = f, f = z)) : (le = f, f = z)), f !== z ? (he = u, i = bt(a, f), u = i) : (le = u, u = z)) : (le = u, u = z)) : (le = u, u = z)) : (le = u, u = z), u === z && (u = le, r.substr(le, 8) === wt ? (i = wt, le += 8) : (i = z, 0 === me && c(Mt)), i !== z ? (a = T(), a !== z ? (r.substr(le, 4) === Tt ? (s = Tt, le += 4) : (s = z, 0 === me && c(Ot)), s !== z ? (he = u, i = St(a), u = i) : (le = u, u = z)) : (le = u, u = z)) : (le = u, u = z), u === z && (u = le, r.substr(le, 3) === Ht ? (i = Ht, le += 3) : (i = z, 0 === me && c(Nt)), i !== z && (he = u, i = Rt()), (u = i) === z && (u = le, r.substr(le, 4) === Gt ? (i = Gt, le += 4) : (i = z, 0 === me && c(Yt)), i !== z && (he = u, i = Bt()), (u = i) === z && (u = le, r.substr(le, 4) === Pt ? (i = Pt, le += 4) : (i = z, 0 === me && c(_t)), i !== z && (he = u, i = Lt()), (u = i) === z && (u = le, 12391 === r.charCodeAt(le) ? (i = vt, le++) : (i = z, 0 === me && c(mt)), i === z && (i = null), i !== z ? (35440 === r.charCodeAt(le) ? (a = jt, le++) : (a = z, 0 === me && c(Wt)), a !== z ? (12415 === r.charCodeAt(le) ? (s = Dt, le++) : (s = z, 0 === me && c(zt)), s === z && (s = null), s !== z ? (he = u, i = Jt(), u = i) : (le = u, u = z)) : (le = u, u = z)) : (le = u, u = z), u === z && (u = le, r.substr(le, 3) === Vt ? (i = Vt, le += 3) : (i = z, 0 === me && c(Zt)), i !== z && (he = u, i = $t()), u = i)))))), u !== z ? (i = O(), i !== z ? (he = t, e = qt(u), t = e) : (le = t, t = z)) : (le = t, t = z)) : (le = t, t = z)) : (le = t, t = z);
      } else le = t, t = z;

      return t;
    }

    function M() {
      var t, e, o, n, u, i, a;

      if (t = le, r.substr(le, 3) === Qt ? (e = Qt, le += 3) : (e = z, 0 === me && c(Xt)), e !== z) {
        for (o = [], 32 === r.charCodeAt(le) ? (n = ir, le++) : (n = z, 0 === me && c(ar)); n !== z;) {
          o.push(n), 32 === r.charCodeAt(le) ? (n = ir, le++) : (n = z, 0 === me && c(ar));
        }

        if (o !== z) {
          if (n = [], lt.test(r.charAt(le)) ? (u = r.charAt(le), le++) : (u = z, 0 === me && c(ht)), u !== z) for (; u !== z;) {
            n.push(u), lt.test(r.charAt(le)) ? (u = r.charAt(le), le++) : (u = z, 0 === me && c(ht));
          } else n = z;
          n !== z ? (25163 === r.charCodeAt(le) ? (u = pt, le++) : (u = z, 0 === me && c(dt)), u !== z ? (i = O(), i !== z ? (a = m(), a !== z ? (he = t, e = re(n, a), t = e) : (le = t, t = z)) : (le = t, t = z)) : (le = t, t = z)) : (le = t, t = z);
        } else le = t, t = z;
      } else le = t, t = z;

      return t;
    }

    function T() {
      var t;
      return tr.test(r.charAt(le)) ? (t = r.charAt(le), le++) : (t = z, 0 === me && c(er)), t;
    }

    function O() {
      var r, t, e, o;
      if (r = le, t = [], (e = N()) !== z) for (; e !== z;) {
        t.push(e), e = N();
      } else t = z;

      if (t !== z) {
        for (e = [], o = S(); o !== z;) {
          e.push(o), o = S();
        }

        e !== z ? (t = [t, e], r = t) : (le = r, r = z);
      } else le = r, r = z;

      return r;
    }

    function S() {
      var t, e, o, n;

      if (t = le, 35 === r.charCodeAt(le) ? (e = te, le++) : (e = z, 0 === me && c(ee)), e !== z) {
        for (o = [], n = R(); n !== z;) {
          o.push(n), n = R();
        }

        o !== z ? (n = N(), n !== z ? (e = [e, o, n], t = e) : (le = t, t = z)) : (le = t, t = z);
      } else le = t, t = z;

      return t;
    }

    function H() {
      var t;
      return 32 === r.charCodeAt(le) ? (t = ir, le++) : (t = z, 0 === me && c(ar)), t === z && (9 === r.charCodeAt(le) ? (t = oe, le++) : (t = z, 0 === me && c(ne))), t;
    }

    function N() {
      var t, e, o, n, u;

      for (t = le, e = [], o = H(); o !== z;) {
        e.push(o), o = H();
      }

      return e !== z ? (10 === r.charCodeAt(le) ? (o = ue, le++) : (o = z, 0 === me && c(ie)), o === z && (o = le, 13 === r.charCodeAt(le) ? (n = ae, le++) : (n = z, 0 === me && c(ce)), n !== z ? (10 === r.charCodeAt(le) ? (u = ue, le++) : (u = z, 0 === me && c(ie)), u === z && (u = null), u !== z ? (n = [n, u], o = n) : (le = o, o = z)) : (le = o, o = z)), o !== z ? (e = [e, o], t = e) : (le = t, t = z)) : (le = t, t = z), t;
    }

    function R() {
      var t;
      return se.test(r.charAt(le)) ? (t = r.charAt(le), le++) : (t = z, 0 === me && c(fe)), t;
    }

    function G(r) {
      return "０１２３４５６７８９".indexOf(r);
    }

    function Y(r) {
      return "〇一二三四五六七八九".indexOf(r);
    }

    function B(r) {
      switch (r.length) {
        case 1:
          return "〇一二三四五六七八九十".indexOf(r);

        case 2:
          return "〇一二三四五六七八九十".indexOf(r[1]) + 10;

        default:
          throw "21以上の数値に対応していません";
      }
    }

    function P(r) {
      return "成" == r[0] ? {
        "香": "NY",
        "桂": "NK",
        "銀": "NG"
      }[r[1]] : {
        "歩": "FU",
        "香": "KY",
        "桂": "KE",
        "銀": "GI",
        "金": "KI",
        "角": "KA",
        "飛": "HI",
        "玉": "OU",
        "王": "OU",
        "と": "TO",
        "杏": "NY",
        "圭": "NK",
        "全": "NG",
        "馬": "UM",
        "竜": "RY",
        "龍": "RY"
      }[r];
    }

    function _(r) {
      return {
        "左": "L",
        "直": "C",
        "右": "R"
      }[r] || "";
    }

    function L(r) {
      return {
        "上": "U",
        "寄": "M",
        "引": "D"
      }[r] || "";
    }

    function j(r) {
      return {
        "平手": "HIRATE",
        "香落ち": "KY",
        "右香落ち": "KY_R",
        "角落ち": "KA",
        "飛車落ち": "HI",
        "飛香落ち": "HIKY",
        "二枚落ち": "2",
        "三枚落ち": "3",
        "四枚落ち": "4",
        "五枚落ち": "5",
        "左五枚落ち": "5_L",
        "六枚落ち": "6",
        "八枚落ち": "8",
        "十枚落ち": "10",
        "その他": "OTHER"
      }[r.replace(/\s/g, "")];
    }

    function W(r) {
      var t = r.replace(/　$/, "").split("　"),
          e = {
        FU: 0,
        KY: 0,
        KE: 0,
        GI: 0,
        KI: 0,
        KA: 0,
        HI: 0
      };
      if ("" == r) return e;

      for (var o = 0; o < t.length; o++) {
        e[P(t[o][0])] = 1 == t[o].length ? 1 : B(t[o].slice(1));
      }

      return e;
    }

    t = void 0 !== t ? t : {};

    var D,
        z = {},
        J = {
      kifu: f
    },
        V = f,
        Z = function Z(r, t, e, o, n) {
      for (var u = {
        header: {},
        moves: o
      }, i = 0; i < r.length; i++) {
        u.header[r[i].k] = r[i].v;
      }

      for (var i = 0; i < e.length; i++) {
        u.header[e[i].k] = e[i].v;
      }

      if (t) u.initial = t;else if (u.header["手合割"]) {
        var a = j(u.header["手合割"]);
        "OTHER" != a && (u.initial = {
          preset: a
        });
      }
      u.initial && u.initial.data && (u.header["手番"] ? (u.initial.data.color = "下先".indexOf(u.header["手番"]) >= 0 ? 0 : 1, delete u.header["手番"]) : u.initial.data.color = 0, u.initial.data.hands = [W(u.header["先手の持駒"] || u.header["下手の持駒"]), W(u.header["後手の持駒"] || u.header["上手の持駒"])], delete u.header["先手の持駒"], delete u.header["下手の持駒"], delete u.header["後手の持駒"], delete u.header["上手の持駒"]);

      for (var c = [{
        te: 0,
        moves: o
      }], i = 0; i < n.length; i++) {
        for (var s = n[i], f = c.pop(); f.te >= s.te;) {
          f = c.pop();
        }

        var l = f.moves[s.te - f.te];
        l.forks = l.forks || [], l.forks.push(s.moves), c.push(f), c.push(s);
      }

      return u;
    },
        $ = /^[^\uFF1A\r\n]/,
        q = n(["：", "\r", "\n"], !0, !1),
        Q = "：",
        X = e("：", !1),
        rr = function rr(r, t) {
      return {
        k: r.join(""),
        v: t.join("")
      };
    },
        tr = /^[\u5148\u5F8C\u4E0A\u4E0B]/,
        er = n(["先", "後", "上", "下"], !1, !1),
        or = "手番",
        nr = e("手番", !1),
        ur = function ur(r) {
      return {
        k: "手番",
        v: r
      };
    },
        ir = " ",
        ar = e(" ", !1),
        cr = "+",
        sr = e("+", !1),
        fr = function fr(r) {
      for (var t = [], e = 0; e < 9; e++) {
        for (var o = [], n = 0; n < 9; n++) {
          o.push(r[n][8 - e]);
        }

        t.push(o);
      }

      return {
        preset: "OTHER",
        data: {
          board: t
        }
      };
    },
        lr = "|",
        hr = e("|", !1),
        pr = function pr(r) {
      return r;
    },
        dr = function dr(r, t) {
      return {
        color: r,
        kind: t
      };
    },
        vr = " ・",
        mr = e(" ・", !1),
        Ar = function Ar() {
      return {};
    },
        gr = "^",
        kr = e("^", !1),
        yr = function yr() {
      return 0;
    },
        Kr = "v",
        Ir = e("v", !1),
        Cr = "V",
        Fr = e("V", !1),
        xr = function xr() {
      return 1;
    },
        Er = function Er(r, t, e) {
      return t.unshift(r), e && !t[t.length - 1].special && t.push({
        special: e
      }), t;
    },
        Ur = function Ur(r) {
      return 0 == r.length ? {} : {
        comments: r
      };
    },
        br = function br(r, t) {
      var e = {
        move: r
      };
      return t.length > 0 && (e.comments = t), e;
    },
        wr = "&",
        Mr = e("&", !1),
        Tr = /^[\u25B2\u25B3]/,
        Or = n(["▲", "△"], !1, !1),
        Sr = function Sr(r) {
      return r;
    },
        Hr = "成",
        Nr = e("成", !1),
        Rr = "不成",
        Gr = e("不成", !1),
        Yr = "打",
        Br = e("打", !1),
        Pr = function Pr(r, t, e, o, n, u) {
      var i = {
        piece: t
      };
      if (r.same ? i.same = !0 : i.to = r, n && (i.promote = "成" == n), u) i.relative = "H";else {
        var a = _(e) + L(o);
        "" != a && (i.relative = a);
      }
      return i;
    },
        _r = function _r(r, t) {
      return {
        x: r,
        y: t
      };
    },
        Lr = "同",
        jr = e("同", !1),
        Wr = "　",
        Dr = e("　", !1),
        zr = function zr() {
      return {
        same: !0
      };
    },
        Jr = /^[\u6B69\u9999\u6842\u9280\u91D1\u89D2\u98DB\u738B\u7389\u3068\u674F\u572D\u5168\u99AC\u7ADC\u9F8D]/,
        Vr = n(["歩", "香", "桂", "銀", "金", "角", "飛", "王", "玉", "と", "杏", "圭", "全", "馬", "竜", "龍"], !1, !1),
        Zr = function Zr(r, t) {
      return P((r || "") + t);
    },
        $r = /^[\u5DE6\u76F4\u53F3]/,
        qr = n(["左", "直", "右"], !1, !1),
        Qr = /^[\u4E0A\u5BC4\u5F15]/,
        Xr = n(["上", "寄", "引"], !1, !1),
        rt = /^[\uFF11\uFF12\uFF13\uFF14\uFF15\uFF16\uFF17\uFF18\uFF19]/,
        tt = n(["１", "２", "３", "４", "５", "６", "７", "８", "９"], !1, !1),
        et = function et(r) {
      return G(r);
    },
        ot = /^[\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D]/,
        nt = n(["一", "二", "三", "四", "五", "六", "七", "八", "九"], !1, !1),
        ut = function ut(r) {
      return Y(r);
    },
        it = "*",
        at = e("*", !1),
        ct = function ct(r) {
      return r.join("");
    },
        st = "まで",
        ft = e("まで", !1),
        lt = /^[0-9]/,
        ht = n([["0", "9"]], !1, !1),
        pt = "手",
        dt = e("手", !1),
        vt = "で",
        mt = e("で", !1),
        At = "手の",
        gt = e("手の", !1),
        kt = "勝ち",
        yt = e("勝ち", !1),
        Kt = function Kt(r) {
      return "TORYO";
    },
        It = "反則",
        Ct = e("反則", !1),
        Ft = function Ft(r) {
      return "ILLEGAL_ACTION";
    },
        xt = "負け",
        Et = e("負け", !1),
        Ut = function Ut(r) {
      return "ILLEGAL_MOVE";
    },
        bt = function bt(r, t) {
      return t;
    },
        wt = "で時間切れにより",
        Mt = e("で時間切れにより", !1),
        Tt = "手の勝ち",
        Ot = e("手の勝ち", !1),
        St = function St(r) {
      return "TIME_UP";
    },
        Ht = "で中断",
        Nt = e("で中断", !1),
        Rt = function Rt() {
      return "CHUDAN";
    },
        Gt = "で持将棋",
        Yt = e("で持将棋", !1),
        Bt = function Bt() {
      return "JISHOGI";
    },
        Pt = "で千日手",
        _t = e("で千日手", !1),
        Lt = function Lt() {
      return "SENNICHITE";
    },
        jt = "詰",
        Wt = e("詰", !1),
        Dt = "み",
        zt = e("み", !1),
        Jt = function Jt() {
      return "TSUMI";
    },
        Vt = "で不詰",
        Zt = e("で不詰", !1),
        $t = function $t() {
      return "FUZUMI";
    },
        qt = function qt(r) {
      return r;
    },
        Qt = "変化：",
        Xt = e("変化：", !1),
        re = function re(r, t) {
      return {
        te: parseInt(r.join("")),
        moves: t.slice(1)
      };
    },
        te = "#",
        ee = e("#", !1),
        oe = "\t",
        ne = e("\t", !1),
        ue = "\n",
        ie = e("\n", !1),
        ae = "\r",
        ce = e("\r", !1),
        se = /^[^\r\n]/,
        fe = n(["\r", "\n"], !0, !1),
        le = 0,
        he = 0,
        pe = [{
      line: 1,
      column: 1
    }],
        de = 0,
        ve = [],
        me = 0;

    if ("startRule" in t) {
      if (!(t.startRule in J)) throw new Error("Can't start parsing from rule \"" + t.startRule + '".');
      V = J[t.startRule];
    }

    if ((D = V()) !== z && le === r.length) return D;
    throw D !== z && le < r.length && c(function () {
      return {
        type: "end"
      };
    }()), s(ve, de < r.length ? r.charAt(de) : null, de < r.length ? a(de, de + 1) : a(de, de));
  }

  !function (r, t) {
    function e() {
      this.constructor = r;
    }

    e.prototype = t.prototype, r.prototype = new e();
  }(o, Error), o.buildMessage = function (r, t) {
    function e(r) {
      return r.charCodeAt(0).toString(16).toUpperCase();
    }

    function o(r) {
      return r.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function (r) {
        return "\\x0" + e(r);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (r) {
        return "\\x" + e(r);
      });
    }

    function n(r) {
      return r.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function (r) {
        return "\\x0" + e(r);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (r) {
        return "\\x" + e(r);
      });
    }

    function u(r) {
      return i[r.type](r);
    }

    var i = {
      literal: function literal(r) {
        return '"' + o(r.text) + '"';
      },
      class: function _class(r) {
        var t,
            e = "";

        for (t = 0; t < r.parts.length; t++) {
          e += r.parts[t] instanceof Array ? n(r.parts[t][0]) + "-" + n(r.parts[t][1]) : n(r.parts[t]);
        }

        return "[" + (r.inverted ? "^" : "") + e + "]";
      },
      any: function any(r) {
        return "any character";
      },
      end: function end(r) {
        return "end of input";
      },
      other: function other(r) {
        return r.description;
      }
    };
    return "Expected " + function (r) {
      var t,
          e,
          o = new Array(r.length);

      for (t = 0; t < r.length; t++) {
        o[t] = u(r[t]);
      }

      if (o.sort(), o.length > 0) {
        for (t = 1, e = 1; t < o.length; t++) {
          o[t - 1] !== o[t] && (o[e] = o[t], e++);
        }

        o.length = e;
      }

      switch (o.length) {
        case 1:
          return o[0];

        case 2:
          return o[0] + " or " + o[1];

        default:
          return o.slice(0, -1).join(", ") + ", or " + o[o.length - 1];
      }
    }(r) + " but " + function (r) {
      return r ? '"' + o(r) + '"' : "end of input";
    }(t) + " found.";
  }, r.exports = {
    SyntaxError: o,
    parse: n
  };
}, function (r, t, e) {
  "use strict";

  function o(r, t, e, n) {
    this.message = r, this.expected = t, this.found = e, this.location = n, this.name = "SyntaxError", "function" == typeof Error.captureStackTrace && Error.captureStackTrace(this, o);
  }

  function n(r, t) {
    function e(r, t) {
      return {
        type: "literal",
        text: r,
        ignoreCase: t
      };
    }

    function n(r, t, e) {
      return {
        type: "class",
        parts: r,
        inverted: t,
        ignoreCase: e
      };
    }

    function u(r) {
      return {
        type: "other",
        description: r
      };
    }

    function i(t) {
      var e,
          o = He[t];
      if (o) return o;

      for (e = t - 1; !He[e];) {
        e--;
      }

      for (o = He[e], o = {
        line: o.line,
        column: o.column
      }; e < t;) {
        10 === r.charCodeAt(e) ? (o.line++, o.column = 1) : o.column++, e++;
      }

      return He[t] = o, o;
    }

    function a(r, t) {
      var e = i(r),
          o = i(t);
      return {
        start: {
          offset: r,
          line: e.line,
          column: e.column
        },
        end: {
          offset: t,
          line: o.line,
          column: o.column
        }
      };
    }

    function c(r) {
      Oe < Ne || (Oe > Ne && (Ne = Oe, Re = []), Re.push(r));
    }

    function s(r, t, e) {
      return new o(o.buildMessage(r, t), r, t, e);
    }

    function f() {
      var r, t, e, o, n, u, i, a, c;

      for (r = Oe, t = [], e = G(); e !== $;) {
        t.push(e), e = G();
      }

      if (t !== $) {
        for (e = [], o = l(); o !== $;) {
          e.push(o), o = l();
        }

        if (e !== $) {
          if (o = p(), o === $ && (o = null), o !== $) {
            for (n = [], u = l(); u !== $;) {
              n.push(u), u = l();
            }

            if (n !== $) {
              if (u = A(), u === $ && (u = null), u !== $) {
                if ((i = g()) !== $) {
                  for (a = [], c = N(); c !== $;) {
                    a.push(c), c = N();
                  }

                  a !== $ ? (c = R(), c === $ && (c = null), c !== $ ? (Se = r, t = X(e, o, n, i, a), r = t) : (Oe = r, r = $)) : (Oe = r, r = $);
                } else Oe = r, r = $;
              } else Oe = r, r = $;
            } else Oe = r, r = $;
          } else Oe = r, r = $;
        } else Oe = r, r = $;
      } else Oe = r, r = $;

      return r;
    }

    function l() {
      var t, e, o, n, u;
      if (t = Oe, e = [], rr.test(r.charAt(Oe)) ? (o = r.charAt(Oe), Oe++) : (o = $, 0 === Ge && c(tr)), o !== $) for (; o !== $;) {
        e.push(o), rr.test(r.charAt(Oe)) ? (o = r.charAt(Oe), Oe++) : (o = $, 0 === Ge && c(tr));
      } else e = $;
      if (e !== $) {
        if (65306 === r.charCodeAt(Oe) ? (o = er, Oe++) : (o = $, 0 === Ge && c(or)), o !== $) {
          for (n = [], u = P(); u !== $;) {
            n.push(u), u = P();
          }

          n !== $ ? (u = R(), u !== $ ? (Se = t, e = nr(e, n), t = e) : (Oe = t, t = $)) : (Oe = t, t = $);
        } else Oe = t, t = $;
      } else Oe = t, t = $;
      return t === $ && (t = Oe, e = h(), e !== $ ? (r.substr(Oe, 2) === ur ? (o = ur, Oe += 2) : (o = $, 0 === Ge && c(ir)), o !== $ ? (n = R(), n !== $ ? (Se = t, e = ar(e), t = e) : (Oe = t, t = $)) : (Oe = t, t = $)) : (Oe = t, t = $), t === $ && (t = Oe, r.substr(Oe, 4) === cr ? (e = cr, Oe += 4) : (e = $, 0 === Ge && c(sr)), e !== $ ? (o = R(), o !== $ ? (Se = t, e = fr(), t = e) : (Oe = t, t = $)) : (Oe = t, t = $))), t;
    }

    function h() {
      var t;
      return lr.test(r.charAt(Oe)) ? (t = r.charAt(Oe), Oe++) : (t = $, 0 === Ge && c(hr)), t;
    }

    function p() {
      var t, e, o, n, u, i, a, s;

      if (t = Oe, e = Oe, 32 === r.charCodeAt(Oe) ? (o = pr, Oe++) : (o = $, 0 === Ge && c(dr)), o !== $) {
        for (n = [], u = P(); u !== $;) {
          n.push(u), u = P();
        }

        n !== $ ? (u = R(), u !== $ ? (o = [o, n, u], e = o) : (Oe = e, e = $)) : (Oe = e, e = $);
      } else Oe = e, e = $;

      if (e === $ && (e = null), e !== $) {
        if (o = Oe, 43 === r.charCodeAt(Oe) ? (n = vr, Oe++) : (n = $, 0 === Ge && c(mr)), n !== $) {
          for (u = [], i = P(); i !== $;) {
            u.push(i), i = P();
          }

          u !== $ ? (i = R(), i !== $ ? (n = [n, u, i], o = n) : (Oe = o, o = $)) : (Oe = o, o = $);
        } else Oe = o, o = $;

        if (o === $ && (o = null), o !== $) {
          if (n = [], (u = d()) !== $) for (; u !== $;) {
            n.push(u), u = d();
          } else n = $;

          if (n !== $) {
            if (u = Oe, 43 === r.charCodeAt(Oe) ? (i = vr, Oe++) : (i = $, 0 === Ge && c(mr)), i !== $) {
              for (a = [], s = P(); s !== $;) {
                a.push(s), s = P();
              }

              a !== $ ? (s = R(), s !== $ ? (i = [i, a, s], u = i) : (Oe = u, u = $)) : (Oe = u, u = $);
            } else Oe = u, u = $;

            u === $ && (u = null), u !== $ ? (Se = t, e = Ar(n), t = e) : (Oe = t, t = $);
          } else Oe = t, t = $;
        } else Oe = t, t = $;
      } else Oe = t, t = $;

      return t;
    }

    function d() {
      var t, e, o, n, u, i;

      if (t = Oe, 124 === r.charCodeAt(Oe) ? (e = gr, Oe++) : (e = $, 0 === Ge && c(kr)), e !== $) {
        if (o = [], (n = v()) !== $) for (; n !== $;) {
          o.push(n), n = v();
        } else o = $;
        if (o !== $) {
          if (124 === r.charCodeAt(Oe) ? (n = gr, Oe++) : (n = $, 0 === Ge && c(kr)), n !== $) {
            if (u = [], (i = P()) !== $) for (; i !== $;) {
              u.push(i), i = P();
            } else u = $;
            u !== $ ? (i = R(), i !== $ ? (Se = t, e = yr(o), t = e) : (Oe = t, t = $)) : (Oe = t, t = $);
          } else Oe = t, t = $;
        } else Oe = t, t = $;
      } else Oe = t, t = $;

      return t;
    }

    function v() {
      var t, e, o;
      return t = Oe, e = m(), e !== $ ? (o = b(), o !== $ ? (Se = t, e = Kr(e, o), t = e) : (Oe = t, t = $)) : (Oe = t, t = $), t === $ && (t = Oe, r.substr(Oe, 2) === Ir ? (e = Ir, Oe += 2) : (e = $, 0 === Ge && c(Cr)), e !== $ && (Se = t, e = Fr()), t = e), t;
    }

    function m() {
      var t, e;
      return t = Oe, 32 === r.charCodeAt(Oe) ? (e = pr, Oe++) : (e = $, 0 === Ge && c(dr)), e === $ && (43 === r.charCodeAt(Oe) ? (e = vr, Oe++) : (e = $, 0 === Ge && c(mr)), e === $ && (94 === r.charCodeAt(Oe) ? (e = xr, Oe++) : (e = $, 0 === Ge && c(Er)))), e !== $ && (Se = t, e = Ur()), t = e, t === $ && (t = Oe, 118 === r.charCodeAt(Oe) ? (e = br, Oe++) : (e = $, 0 === Ge && c(wr)), e === $ && (86 === r.charCodeAt(Oe) ? (e = Mr, Oe++) : (e = $, 0 === Ge && c(Tr))), e !== $ && (Se = t, e = Or()), t = e), t;
    }

    function A() {
      var t, e, o, n;
      return t = Oe, r.substr(Oe, 10) === Sr ? (e = Sr, Oe += 10) : (e = $, 0 === Ge && c(Hr)), e !== $ ? (r.substr(Oe, 13) === Nr ? (o = Nr, Oe += 13) : (o = $, 0 === Ge && c(Rr)), o === $ && (o = null), o !== $ ? (n = R(), n !== $ ? (e = [e, o, n], t = e) : (Oe = t, t = $)) : (Oe = t, t = $)) : (Oe = t, t = $), t;
    }

    function g() {
      var r, t, e, o, n;
      if (r = Oe, (t = k()) !== $) {
        if (e = A(), e === $ && (e = null), e !== $) {
          for (o = [], n = y(); n !== $;) {
            o.push(n), n = y();
          }

          o !== $ ? (n = H(), n === $ && (n = null), n !== $ ? (Se = r, t = Gr(t, o), r = t) : (Oe = r, r = $)) : (Oe = r, r = $);
        } else Oe = r, r = $;
      } else Oe = r, r = $;
      return r;
    }

    function k() {
      var r, t, e;

      for (r = Oe, t = [], e = S(); e !== $;) {
        t.push(e), e = S();
      }

      return t !== $ ? (e = K(), e === $ && (e = null), e !== $ ? (Se = r, t = Yr(t), r = t) : (Oe = r, r = $)) : (Oe = r, r = $), r;
    }

    function y() {
      var r, t, e, o;

      if (r = Oe, (t = I()) !== $) {
        for (e = [], o = S(); o !== $;) {
          e.push(o), o = S();
        }

        e !== $ ? (o = K(), o === $ && (o = null), o !== $ ? (Se = r, t = Br(t, e), r = t) : (Oe = r, r = $)) : (Oe = r, r = $);
      } else Oe = r, r = $;

      return r;
    }

    function K() {
      var t, e, o, n;

      if (t = Oe, 38 === r.charCodeAt(Oe) ? (e = Pr, Oe++) : (e = $, 0 === Ge && c(_r)), e !== $) {
        for (o = [], n = P(); n !== $;) {
          o.push(n), n = P();
        }

        o !== $ ? (n = R(), n !== $ ? (e = [e, o, n], t = e) : (Oe = t, t = $)) : (Oe = t, t = $);
      } else Oe = t, t = $;

      return t;
    }

    function I() {
      var t, e, o, n, u, i, a, s, f;

      for (t = Oe, e = [], 32 === r.charCodeAt(Oe) ? (o = pr, Oe++) : (o = $, 0 === Ge && c(dr)); o !== $;) {
        e.push(o), 32 === r.charCodeAt(Oe) ? (o = pr, Oe++) : (o = $, 0 === Ge && c(dr));
      }

      if (e !== $) {
        if ((o = C()) !== $) {
          for (n = [], 32 === r.charCodeAt(Oe) ? (u = pr, Oe++) : (u = $, 0 === Ge && c(dr)); u !== $;) {
            n.push(u), 32 === r.charCodeAt(Oe) ? (u = pr, Oe++) : (u = $, 0 === Ge && c(dr));
          }

          if (n !== $) {
            if (u = Oe, i = F(), i !== $ ? (a = w(), a !== $ ? (Se = u, i = Lr(i, a), u = i) : (Oe = u, u = $)) : (Oe = u, u = $), u === $) {
              for (u = Oe, i = [], jr.test(r.charAt(Oe)) ? (a = r.charAt(Oe), Oe++) : (a = $, 0 === Ge && c(Wr)); a !== $;) {
                i.push(a), jr.test(r.charAt(Oe)) ? (a = r.charAt(Oe), Oe++) : (a = $, 0 === Ge && c(Wr));
              }

              i !== $ && (Se = u, i = Dr(i)), u = i;
            }

            if (u !== $) {
              for (i = [], 32 === r.charCodeAt(Oe) ? (a = pr, Oe++) : (a = $, 0 === Ge && c(dr)); a !== $;) {
                i.push(a), 32 === r.charCodeAt(Oe) ? (a = pr, Oe++) : (a = $, 0 === Ge && c(dr));
              }

              i !== $ ? (a = M(), a === $ && (a = null), a !== $ ? (43 === r.charCodeAt(Oe) ? (s = vr, Oe++) : (s = $, 0 === Ge && c(mr)), s === $ && (s = null), s !== $ ? (f = R(), f !== $ ? (Se = t, e = zr(u, a), t = e) : (Oe = t, t = $)) : (Oe = t, t = $)) : (Oe = t, t = $)) : (Oe = t, t = $);
            } else Oe = t, t = $;
          } else Oe = t, t = $;
        } else Oe = t, t = $;
      } else Oe = t, t = $;
      return t;
    }

    function C() {
      var t, e;
      if (t = [], Jr.test(r.charAt(Oe)) ? (e = r.charAt(Oe), Oe++) : (e = $, 0 === Ge && c(Vr)), e !== $) for (; e !== $;) {
        t.push(e), Jr.test(r.charAt(Oe)) ? (e = r.charAt(Oe), Oe++) : (e = $, 0 === Ge && c(Vr));
      } else t = $;
      return t;
    }

    function F() {
      var t, e, o, n;
      return t = Oe, e = x(), e !== $ ? (o = b(), o !== $ ? (25104 === r.charCodeAt(Oe) ? (n = Zr, Oe++) : (n = $, 0 === Ge && c($r)), n === $ && (n = null), n !== $ ? (Se = t, e = qr(e, o, n), t = e) : (Oe = t, t = $)) : (Oe = t, t = $)) : (Oe = t, t = $), t;
    }

    function x() {
      var t, e, o;
      return t = Oe, e = E(), e !== $ ? (o = U(), o !== $ ? (Se = t, e = Qr(e, o), t = e) : (Oe = t, t = $)) : (Oe = t, t = $), t === $ && (t = Oe, 21516 === r.charCodeAt(Oe) ? (e = Xr, Oe++) : (e = $, 0 === Ge && c(rt)), e !== $ ? (12288 === r.charCodeAt(Oe) ? (o = tt, Oe++) : (o = $, 0 === Ge && c(et)), o === $ && (o = null), o !== $ ? (Se = t, e = fr(), t = e) : (Oe = t, t = $)) : (Oe = t, t = $)), t;
    }

    function E() {
      var t, e;
      return t = Oe, ot.test(r.charAt(Oe)) ? (e = r.charAt(Oe), Oe++) : (e = $, 0 === Ge && c(nt)), e !== $ && (Se = t, e = ut(e)), t = e;
    }

    function U() {
      var t, e;
      return t = Oe, it.test(r.charAt(Oe)) ? (e = r.charAt(Oe), Oe++) : (e = $, 0 === Ge && c(at)), e !== $ && (Se = t, e = ct(e)), t = e;
    }

    function b() {
      var t, e, o;
      return t = Oe, 25104 === r.charCodeAt(Oe) ? (e = Zr, Oe++) : (e = $, 0 === Ge && c($r)), e === $ && (e = null), e !== $ ? (st.test(r.charAt(Oe)) ? (o = r.charAt(Oe), Oe++) : (o = $, 0 === Ge && c(ft)), o !== $ ? (Se = t, e = lt(e, o), t = e) : (Oe = t, t = $)) : (Oe = t, t = $), t;
    }

    function w() {
      var t, e, o, n, u;
      return t = Oe, 25171 === r.charCodeAt(Oe) ? (e = ht, Oe++) : (e = $, 0 === Ge && c(pt)), e !== $ && (Se = t, e = fr()), t = e, t === $ && (t = Oe, 40 === r.charCodeAt(Oe) ? (e = dt, Oe++) : (e = $, 0 === Ge && c(vt)), e !== $ ? (mt.test(r.charAt(Oe)) ? (o = r.charAt(Oe), Oe++) : (o = $, 0 === Ge && c(At)), o !== $ ? (mt.test(r.charAt(Oe)) ? (n = r.charAt(Oe), Oe++) : (n = $, 0 === Ge && c(At)), n !== $ ? (41 === r.charCodeAt(Oe) ? (u = gt, Oe++) : (u = $, 0 === Ge && c(kt)), u !== $ ? (Se = t, e = yt(o, n), t = e) : (Oe = t, t = $)) : (Oe = t, t = $)) : (Oe = t, t = $)) : (Oe = t, t = $)), t;
    }

    function M() {
      var t, e, o, n, u, i, a;

      if (t = Oe, 40 === r.charCodeAt(Oe) ? (e = dt, Oe++) : (e = $, 0 === Ge && c(vt)), e !== $) {
        for (o = [], 32 === r.charCodeAt(Oe) ? (n = pr, Oe++) : (n = $, 0 === Ge && c(dr)); n !== $;) {
          o.push(n), 32 === r.charCodeAt(Oe) ? (n = pr, Oe++) : (n = $, 0 === Ge && c(dr));
        }

        o !== $ ? (n = O(), n !== $ ? (47 === r.charCodeAt(Oe) ? (u = Kt, Oe++) : (u = $, 0 === Ge && c(It)), u !== $ ? (i = T(), i !== $ ? (41 === r.charCodeAt(Oe) ? (a = gt, Oe++) : (a = $, 0 === Ge && c(kt)), a !== $ ? (Se = t, e = Ct(n, i), t = e) : (Oe = t, t = $)) : (Oe = t, t = $)) : (Oe = t, t = $)) : (Oe = t, t = $)) : (Oe = t, t = $);
      } else Oe = t, t = $;

      return t;
    }

    function T() {
      var t, e, o, n, u, i, a;
      if (t = Oe, e = [], Jr.test(r.charAt(Oe)) ? (o = r.charAt(Oe), Oe++) : (o = $, 0 === Ge && c(Vr)), o !== $) for (; o !== $;) {
        e.push(o), Jr.test(r.charAt(Oe)) ? (o = r.charAt(Oe), Oe++) : (o = $, 0 === Ge && c(Vr));
      } else e = $;
      if (e !== $) {
        if (58 === r.charCodeAt(Oe) ? (o = Ft, Oe++) : (o = $, 0 === Ge && c(xt)), o !== $) {
          if (n = [], Jr.test(r.charAt(Oe)) ? (u = r.charAt(Oe), Oe++) : (u = $, 0 === Ge && c(Vr)), u !== $) for (; u !== $;) {
            n.push(u), Jr.test(r.charAt(Oe)) ? (u = r.charAt(Oe), Oe++) : (u = $, 0 === Ge && c(Vr));
          } else n = $;
          if (n !== $) {
            if (58 === r.charCodeAt(Oe) ? (u = Ft, Oe++) : (u = $, 0 === Ge && c(xt)), u !== $) {
              if (i = [], Jr.test(r.charAt(Oe)) ? (a = r.charAt(Oe), Oe++) : (a = $, 0 === Ge && c(Vr)), a !== $) for (; a !== $;) {
                i.push(a), Jr.test(r.charAt(Oe)) ? (a = r.charAt(Oe), Oe++) : (a = $, 0 === Ge && c(Vr));
              } else i = $;
              i !== $ ? (Se = t, e = Et(e, n, i), t = e) : (Oe = t, t = $);
            } else Oe = t, t = $;
          } else Oe = t, t = $;
        } else Oe = t, t = $;
      } else Oe = t, t = $;
      return t;
    }

    function O() {
      var t, e, o, n, u;
      if (t = Oe, e = [], Jr.test(r.charAt(Oe)) ? (o = r.charAt(Oe), Oe++) : (o = $, 0 === Ge && c(Vr)), o !== $) for (; o !== $;) {
        e.push(o), Jr.test(r.charAt(Oe)) ? (o = r.charAt(Oe), Oe++) : (o = $, 0 === Ge && c(Vr));
      } else e = $;
      if (e !== $) {
        if (58 === r.charCodeAt(Oe) ? (o = Ft, Oe++) : (o = $, 0 === Ge && c(xt)), o !== $) {
          if (n = [], Jr.test(r.charAt(Oe)) ? (u = r.charAt(Oe), Oe++) : (u = $, 0 === Ge && c(Vr)), u !== $) for (; u !== $;) {
            n.push(u), Jr.test(r.charAt(Oe)) ? (u = r.charAt(Oe), Oe++) : (u = $, 0 === Ge && c(Vr));
          } else n = $;
          n !== $ ? (Se = t, e = Ut(e, n), t = e) : (Oe = t, t = $);
        } else Oe = t, t = $;
      } else Oe = t, t = $;
      return t;
    }

    function S() {
      var t, e, o, n;

      if (t = Oe, 42 === r.charCodeAt(Oe) ? (e = bt, Oe++) : (e = $, 0 === Ge && c(wt)), e !== $) {
        for (o = [], n = P(); n !== $;) {
          o.push(n), n = P();
        }

        o !== $ ? (n = R(), n !== $ ? (Se = t, e = Mt(o), t = e) : (Oe = t, t = $)) : (Oe = t, t = $);
      } else Oe = t, t = $;

      if (t === $) if (t = Oe, 38 === r.charCodeAt(Oe) ? (e = Pr, Oe++) : (e = $, 0 === Ge && c(_r)), e !== $) {
        for (o = [], n = P(); n !== $;) {
          o.push(n), n = P();
        }

        o !== $ ? (n = R(), n !== $ ? (Se = t, e = Tt(o), t = e) : (Oe = t, t = $)) : (Oe = t, t = $);
      } else Oe = t, t = $;
      return t;
    }

    function H() {
      var t, e, o, n, u, i, a, s, f, l, p, d;

      if (t = Oe, r.substr(Oe, 2) === Ot ? (e = Ot, Oe += 2) : (e = $, 0 === Ge && c(St)), e !== $) {
        if (o = [], Jr.test(r.charAt(Oe)) ? (n = r.charAt(Oe), Oe++) : (n = $, 0 === Ge && c(Vr)), n !== $) for (; n !== $;) {
          o.push(n), Jr.test(r.charAt(Oe)) ? (n = r.charAt(Oe), Oe++) : (n = $, 0 === Ge && c(Vr));
        } else o = $;
        o !== $ ? (25163 === r.charCodeAt(Oe) ? (n = Ht, Oe++) : (n = $, 0 === Ge && c(Nt)), n !== $ ? (u = Oe, 12391 === r.charCodeAt(Oe) ? (i = Rt, Oe++) : (i = $, 0 === Ge && c(Gt)), i !== $ ? (a = h(), a !== $ ? (r.substr(Oe, 2) === Yt ? (s = Yt, Oe += 2) : (s = $, 0 === Ge && c(Bt)), s !== $ ? (f = Oe, r.substr(Oe, 2) === Pt ? (l = Pt, Oe += 2) : (l = $, 0 === Ge && c(_t)), l !== $ && (Se = f, l = Lt(a)), f = l, f === $ && (f = Oe, r.substr(Oe, 2) === jt ? (l = jt, Oe += 2) : (l = $, 0 === Ge && c(Wt)), l !== $ ? (p = Oe, r.substr(Oe, 2) === Pt ? (d = Pt, Oe += 2) : (d = $, 0 === Ge && c(_t)), d !== $ && (Se = p, d = Dt(a)), p = d, p === $ && (p = Oe, r.substr(Oe, 2) === zt ? (d = zt, Oe += 2) : (d = $, 0 === Ge && c(Jt)), d !== $ && (Se = p, d = Vt(a)), p = d), p !== $ ? (Se = f, l = Zt(a, p), f = l) : (Oe = f, f = $)) : (Oe = f, f = $)), f !== $ ? (Se = u, i = Zt(a, f), u = i) : (Oe = u, u = $)) : (Oe = u, u = $)) : (Oe = u, u = $)) : (Oe = u, u = $), u === $ && (u = Oe, r.substr(Oe, 8) === $t ? (i = $t, Oe += 8) : (i = $, 0 === Ge && c(qt)), i !== $ ? (a = h(), a !== $ ? (r.substr(Oe, 4) === Qt ? (s = Qt, Oe += 4) : (s = $, 0 === Ge && c(Xt)), s !== $ ? (Se = u, i = re(a), u = i) : (Oe = u, u = $)) : (Oe = u, u = $)) : (Oe = u, u = $), u === $ && (u = Oe, r.substr(Oe, 3) === te ? (i = te, Oe += 3) : (i = $, 0 === Ge && c(ee)), i !== $ && (Se = u, i = oe()), (u = i) === $ && (u = Oe, r.substr(Oe, 4) === ne ? (i = ne, Oe += 4) : (i = $, 0 === Ge && c(ue)), i !== $ && (Se = u, i = ie()), (u = i) === $ && (u = Oe, r.substr(Oe, 4) === ae ? (i = ae, Oe += 4) : (i = $, 0 === Ge && c(ce)), i !== $ && (Se = u, i = se()), (u = i) === $ && (u = Oe, 12391 === r.charCodeAt(Oe) ? (i = Rt, Oe++) : (i = $, 0 === Ge && c(Gt)), i === $ && (i = null), i !== $ ? (35440 === r.charCodeAt(Oe) ? (a = fe, Oe++) : (a = $, 0 === Ge && c(le)), a !== $ ? (12415 === r.charCodeAt(Oe) ? (s = he, Oe++) : (s = $, 0 === Ge && c(pe)), s === $ && (s = null), s !== $ ? (Se = u, i = de(), u = i) : (Oe = u, u = $)) : (Oe = u, u = $)) : (Oe = u, u = $), u === $ && (u = Oe, r.substr(Oe, 3) === ve ? (i = ve, Oe += 3) : (i = $, 0 === Ge && c(me)), i !== $ && (Se = u, i = Ae()), u = i)))))), u !== $ ? (i = R(), i !== $ ? (Se = t, e = ge(u), t = e) : (Oe = t, t = $)) : (Oe = t, t = $)) : (Oe = t, t = $)) : (Oe = t, t = $);
      } else Oe = t, t = $;

      return t;
    }

    function N() {
      var t, e, o, n, u, i, a;

      if (t = Oe, r.substr(Oe, 3) === ke ? (e = ke, Oe += 3) : (e = $, 0 === Ge && c(ye)), e !== $) {
        for (o = [], 32 === r.charCodeAt(Oe) ? (n = pr, Oe++) : (n = $, 0 === Ge && c(dr)); n !== $;) {
          o.push(n), 32 === r.charCodeAt(Oe) ? (n = pr, Oe++) : (n = $, 0 === Ge && c(dr));
        }

        if (o !== $) {
          if (n = [], Jr.test(r.charAt(Oe)) ? (u = r.charAt(Oe), Oe++) : (u = $, 0 === Ge && c(Vr)), u !== $) for (; u !== $;) {
            n.push(u), Jr.test(r.charAt(Oe)) ? (u = r.charAt(Oe), Oe++) : (u = $, 0 === Ge && c(Vr));
          } else n = $;
          n !== $ ? (25163 === r.charCodeAt(Oe) ? (u = Ht, Oe++) : (u = $, 0 === Ge && c(Nt)), u !== $ ? (i = R(), i !== $ ? (a = g(), a !== $ ? (Se = t, e = Ke(n, a), t = e) : (Oe = t, t = $)) : (Oe = t, t = $)) : (Oe = t, t = $)) : (Oe = t, t = $);
        } else Oe = t, t = $;
      } else Oe = t, t = $;

      return t;
    }

    function R() {
      var r, t, e, o;
      if (r = Oe, t = [], (e = B()) !== $) for (; e !== $;) {
        t.push(e), e = B();
      } else t = $;

      if (t !== $) {
        for (e = [], o = G(); o !== $;) {
          e.push(o), o = G();
        }

        e !== $ ? (t = [t, e], r = t) : (Oe = r, r = $);
      } else Oe = r, r = $;

      return r;
    }

    function G() {
      var t, e, o, n;

      if (t = Oe, 35 === r.charCodeAt(Oe) ? (e = Ie, Oe++) : (e = $, 0 === Ge && c(Ce)), e !== $) {
        for (o = [], n = P(); n !== $;) {
          o.push(n), n = P();
        }

        o !== $ ? (n = B(), n !== $ ? (e = [e, o, n], t = e) : (Oe = t, t = $)) : (Oe = t, t = $);
      } else Oe = t, t = $;

      return t;
    }

    function Y() {
      var t;
      return 32 === r.charCodeAt(Oe) ? (t = pr, Oe++) : (t = $, 0 === Ge && c(dr)), t === $ && (9 === r.charCodeAt(Oe) ? (t = Fe, Oe++) : (t = $, 0 === Ge && c(xe))), t;
    }

    function B() {
      var t, e, o, n, u;

      for (t = Oe, e = [], o = Y(); o !== $;) {
        e.push(o), o = Y();
      }

      return e !== $ ? (10 === r.charCodeAt(Oe) ? (o = Ee, Oe++) : (o = $, 0 === Ge && c(Ue)), o === $ && (o = Oe, 13 === r.charCodeAt(Oe) ? (n = be, Oe++) : (n = $, 0 === Ge && c(we)), n !== $ ? (10 === r.charCodeAt(Oe) ? (u = Ee, Oe++) : (u = $, 0 === Ge && c(Ue)), u === $ && (u = null), u !== $ ? (n = [n, u], o = n) : (Oe = o, o = $)) : (Oe = o, o = $)), o !== $ ? (e = [e, o], t = e) : (Oe = t, t = $)) : (Oe = t, t = $), t;
    }

    function P() {
      var t;
      return Me.test(r.charAt(Oe)) ? (t = r.charAt(Oe), Oe++) : (t = $, 0 === Ge && c(Te)), t;
    }

    function _(r) {
      return parseInt(r.join(""), 10);
    }

    function L(r) {
      return "０１２３４５６７８９".indexOf(r);
    }

    function j(r) {
      return "〇一二三四五六七八九".indexOf(r);
    }

    function W(r) {
      switch (r.length) {
        case 1:
          return "〇一二三四五六七八九十".indexOf(r);

        case 2:
          return "〇一二三四五六七八九十".indexOf(r[1]) + 10;

        default:
          throw "21以上の数値に対応していません";
      }
    }

    function D(r) {
      return "成" == r[0] ? {
        "香": "NY",
        "桂": "NK",
        "銀": "NG"
      }[r[1]] : {
        "歩": "FU",
        "香": "KY",
        "桂": "KE",
        "銀": "GI",
        "金": "KI",
        "角": "KA",
        "飛": "HI",
        "玉": "OU",
        "王": "OU",
        "と": "TO",
        "杏": "NY",
        "圭": "NK",
        "全": "NG",
        "馬": "UM",
        "竜": "RY",
        "龍": "RY"
      }[r];
    }

    function z(r) {
      return {
        "中断": "CHUDAN",
        "投了": "TORYO",
        "持将棋": "JISHOGI",
        "千日手": "SENNICHITE",
        "詰み": "TSUMI",
        "不詰": "FUZUMI",
        "切れ負け": "TIME_UP",
        "反則勝ち": "ILLEGAL_ACTION",
        "反則負け": "ILLEGAL_MOVE"
      }[r];
    }

    function J(r) {
      return {
        "平手": "HIRATE",
        "香落ち": "KY",
        "右香落ち": "KY_R",
        "角落ち": "KA",
        "飛車落ち": "HI",
        "飛香落ち": "HIKY",
        "二枚落ち": "2",
        "三枚落ち": "3",
        "四枚落ち": "4",
        "五枚落ち": "5",
        "左五枚落ち": "5_L",
        "六枚落ち": "6",
        "八枚落ち": "8",
        "十枚落ち": "10",
        "その他": "OTHER"
      }[r.replace(/\s/g, "")];
    }

    function V(r) {
      var t = r.split(/[ 　]/),
          e = {
        FU: 0,
        KY: 0,
        KE: 0,
        GI: 0,
        KI: 0,
        KA: 0,
        HI: 0
      };
      if ("" == r) return e;

      for (var o = 0; o < t.length; o++) {
        "" != t[o] && (e[D(t[o][0])] = 1 == t[o].length ? 1 : W(t[o].slice(1)));
      }

      return e;
    }

    t = void 0 !== t ? t : {};

    var Z,
        $ = {},
        q = {
      kifu: f
    },
        Q = f,
        X = function X(r, t, e, o, n) {
      for (var u = {
        header: {},
        moves: o
      }, i = 0; i < r.length; i++) {
        r[i] && (u.header[r[i].k] = r[i].v);
      }

      for (var i = 0; i < e.length; i++) {
        e[i] && (u.header[e[i].k] = e[i].v);
      }

      if (t) u.initial = t;else if (u.header["手合割"]) {
        var a = J(u.header["手合割"]);
        "OTHER" != a && (u.initial = {
          preset: a
        });
      }
      u.initial && u.initial.data && (u.header["手番"] ? (u.initial.data.color = "下先".indexOf(u.header["手番"]) >= 0 ? 0 : 1, delete u.header["手番"]) : u.initial.data.color = 0, u.initial.data.hands = [V(u.header["先手の持駒"] || u.header["下手の持駒"]), V(u.header["後手の持駒"] || u.header["上手の持駒"])], delete u.header["先手の持駒"], delete u.header["下手の持駒"], delete u.header["後手の持駒"], delete u.header["上手の持駒"]);

      for (var c = [{
        te: 0,
        moves: o
      }], i = 0; i < n.length; i++) {
        for (var s = n[i], f = c.pop(); f.te >= s.te;) {
          f = c.pop();
        }

        var l = f.moves[s.te - f.te];
        l.forks = l.forks || [], l.forks.push(s.moves), c.push(f), c.push(s);
      }

      return u;
    },
        rr = /^[^\uFF1A\r\n]/,
        tr = n(["：", "\r", "\n"], !0, !1),
        er = "：",
        or = e("：", !1),
        nr = function nr(r, t) {
      return {
        k: r.join(""),
        v: t.join("")
      };
    },
        ur = "手番",
        ir = e("手番", !1),
        ar = function ar(r) {
      return {
        k: "手番",
        v: r
      };
    },
        cr = "盤面回転",
        sr = e("盤面回転", !1),
        fr = function fr() {
      return null;
    },
        lr = /^[\u5148\u5F8C\u4E0A\u4E0B]/,
        hr = n(["先", "後", "上", "下"], !1, !1),
        pr = " ",
        dr = e(" ", !1),
        vr = "+",
        mr = e("+", !1),
        Ar = function Ar(r) {
      for (var t = [], e = 0; e < 9; e++) {
        for (var o = [], n = 0; n < 9; n++) {
          o.push(r[n][8 - e]);
        }

        t.push(o);
      }

      return {
        preset: "OTHER",
        data: {
          board: t
        }
      };
    },
        gr = "|",
        kr = e("|", !1),
        yr = function yr(r) {
      return r;
    },
        Kr = function Kr(r, t) {
      return {
        color: r,
        kind: t
      };
    },
        Ir = " ・",
        Cr = e(" ・", !1),
        Fr = function Fr() {
      return {};
    },
        xr = "^",
        Er = e("^", !1),
        Ur = function Ur() {
      return 0;
    },
        br = "v",
        wr = e("v", !1),
        Mr = "V",
        Tr = e("V", !1),
        Or = function Or() {
      return 1;
    },
        Sr = "手数----指手--",
        Hr = e("手数----指手--", !1),
        Nr = "-------消費時間--",
        Rr = e("-------消費時間--", !1),
        Gr = function Gr(r, t) {
      return t.unshift(r), t;
    },
        Yr = function Yr(r) {
      return 0 == r.length ? {} : {
        comments: r
      };
    },
        Br = function Br(r, t) {
      var e = {};
      return t.length > 0 && (e.comments = t), "object" == typeof r.move ? e.move = r.move : e.special = z(r.move), r.time && (e.time = r.time), e;
    },
        Pr = "&",
        _r = e("&", !1),
        Lr = function Lr(r, t) {
      var e = {
        piece: r.piece
      };
      return r.to ? e.to = r.to : e.same = !0, r.promote && (e.promote = !0), t && (e.from = t), e;
    },
        jr = /^[^\r\n ]/,
        Wr = n(["\r", "\n", " "], !0, !1),
        Dr = function Dr(r) {
      return r.join("");
    },
        zr = function zr(r, t) {
      return {
        move: r,
        time: t
      };
    },
        Jr = /^[0-9]/,
        Vr = n([["0", "9"]], !1, !1),
        Zr = "成",
        $r = e("成", !1),
        qr = function qr(r, t, e) {
      return {
        to: r,
        piece: t,
        promote: !!e
      };
    },
        Qr = function Qr(r, t) {
      return {
        x: r,
        y: t
      };
    },
        Xr = "同",
        rt = e("同", !1),
        tt = "　",
        et = e("　", !1),
        ot = /^[\uFF11\uFF12\uFF13\uFF14\uFF15\uFF16\uFF17\uFF18\uFF19]/,
        nt = n(["１", "２", "３", "４", "５", "６", "７", "８", "９"], !1, !1),
        ut = function ut(r) {
      return L(r);
    },
        it = /^[\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D]/,
        at = n(["一", "二", "三", "四", "五", "六", "七", "八", "九"], !1, !1),
        ct = function ct(r) {
      return j(r);
    },
        st = /^[\u6B69\u9999\u6842\u9280\u91D1\u89D2\u98DB\u738B\u7389\u3068\u674F\u572D\u5168\u99AC\u7ADC\u9F8D]/,
        ft = n(["歩", "香", "桂", "銀", "金", "角", "飛", "王", "玉", "と", "杏", "圭", "全", "馬", "竜", "龍"], !1, !1),
        lt = function lt(r, t) {
      return D((r || "") + t);
    },
        ht = "打",
        pt = e("打", !1),
        dt = "(",
        vt = e("(", !1),
        mt = /^[1-9]/,
        At = n([["1", "9"]], !1, !1),
        gt = ")",
        kt = e(")", !1),
        yt = function yt(r, t) {
      return {
        x: parseInt(r),
        y: parseInt(t)
      };
    },
        Kt = "/",
        It = e("/", !1),
        Ct = function Ct(r, t) {
      return {
        now: r,
        total: t
      };
    },
        Ft = ":",
        xt = e(":", !1),
        Et = function Et(r, t, e) {
      return {
        h: _(r),
        m: _(t),
        s: _(e)
      };
    },
        Ut = function Ut(r, t) {
      return {
        m: _(r),
        s: _(t)
      };
    },
        bt = "*",
        wt = e("*", !1),
        Mt = function Mt(r) {
      return r.join("");
    },
        Tt = function Tt(r) {
      return "&" + r.join("");
    },
        Ot = "まで",
        St = e("まで", !1),
        Ht = "手",
        Nt = e("手", !1),
        Rt = "で",
        Gt = e("で", !1),
        Yt = "手の",
        Bt = e("手の", !1),
        Pt = "勝ち",
        _t = e("勝ち", !1),
        Lt = function Lt(r) {
      return "TORYO";
    },
        jt = "反則",
        Wt = e("反則", !1),
        Dt = function Dt(r) {
      return "ILLEGAL_ACTION";
    },
        zt = "負け",
        Jt = e("負け", !1),
        Vt = function Vt(r) {
      return "ILLEGAL_MOVE";
    },
        Zt = function Zt(r, t) {
      return t;
    },
        $t = "で時間切れにより",
        qt = e("で時間切れにより", !1),
        Qt = "手の勝ち",
        Xt = e("手の勝ち", !1),
        re = function re(r) {
      return "TIME_UP";
    },
        te = "で中断",
        ee = e("で中断", !1),
        oe = function oe() {
      return "CHUDAN";
    },
        ne = "で持将棋",
        ue = e("で持将棋", !1),
        ie = function ie() {
      return "JISHOGI";
    },
        ae = "で千日手",
        ce = e("で千日手", !1),
        se = function se() {
      return "SENNICHITE";
    },
        fe = "詰",
        le = e("詰", !1),
        he = "み",
        pe = e("み", !1),
        de = function de() {
      return "TSUMI";
    },
        ve = "で不詰",
        me = e("で不詰", !1),
        Ae = function Ae() {
      return "FUZUMI";
    },
        ge = function ge(r) {
      return r;
    },
        ke = "変化：",
        ye = e("変化：", !1),
        Ke = function Ke(r, t) {
      return {
        te: parseInt(r.join("")),
        moves: t.slice(1)
      };
    },
        Ie = "#",
        Ce = e("#", !1),
        Fe = "\t",
        xe = e("\t", !1),
        Ee = "\n",
        Ue = e("\n", !1),
        be = "\r",
        we = e("\r", !1),
        Me = /^[^\r\n]/,
        Te = n(["\r", "\n"], !0, !1),
        Oe = 0,
        Se = 0,
        He = [{
      line: 1,
      column: 1
    }],
        Ne = 0,
        Re = [],
        Ge = 0;

    if ("startRule" in t) {
      if (!(t.startRule in q)) throw new Error("Can't start parsing from rule \"" + t.startRule + '".');
      Q = q[t.startRule];
    }

    if ((Z = Q()) !== $ && Oe === r.length) return Z;
    throw Z !== $ && Oe < r.length && c(function () {
      return {
        type: "end"
      };
    }()), s(Re, Ne < r.length ? r.charAt(Ne) : null, Ne < r.length ? a(Ne, Ne + 1) : a(Ne, Ne));
  }

  !function (r, t) {
    function e() {
      this.constructor = r;
    }

    e.prototype = t.prototype, r.prototype = new e();
  }(o, Error), o.buildMessage = function (r, t) {
    function e(r) {
      return r.charCodeAt(0).toString(16).toUpperCase();
    }

    function o(r) {
      return r.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function (r) {
        return "\\x0" + e(r);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (r) {
        return "\\x" + e(r);
      });
    }

    function n(r) {
      return r.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function (r) {
        return "\\x0" + e(r);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function (r) {
        return "\\x" + e(r);
      });
    }

    function u(r) {
      return i[r.type](r);
    }

    var i = {
      literal: function literal(r) {
        return '"' + o(r.text) + '"';
      },
      class: function _class(r) {
        var t,
            e = "";

        for (t = 0; t < r.parts.length; t++) {
          e += r.parts[t] instanceof Array ? n(r.parts[t][0]) + "-" + n(r.parts[t][1]) : n(r.parts[t]);
        }

        return "[" + (r.inverted ? "^" : "") + e + "]";
      },
      any: function any(r) {
        return "any character";
      },
      end: function end(r) {
        return "end of input";
      },
      other: function other(r) {
        return r.description;
      }
    };
    return "Expected " + function (r) {
      var t,
          e,
          o = new Array(r.length);

      for (t = 0; t < r.length; t++) {
        o[t] = u(r[t]);
      }

      if (o.sort(), o.length > 0) {
        for (t = 1, e = 1; t < o.length; t++) {
          o[t - 1] !== o[t] && (o[e] = o[t], e++);
        }

        o.length = e;
      }

      switch (o.length) {
        case 1:
          return o[0];

        case 2:
          return o[0] + " or " + o[1];

        default:
          return o.slice(0, -1).join(", ") + ", or " + o[o.length - 1];
      }
    }(r) + " but " + function (r) {
      return r ? '"' + o(r) + '"' : "end of input";
    }(t) + " found.";
  }, r.exports = {
    SyntaxError: o,
    parse: n
  };
}]);